var map = {
	"./informatyka/assets/ikona_dzwiekOFF_OFF.png": "6a35",
	"./informatyka/assets/ikona_dzwiekON_OFF.png": "6c43",
	"./informatyka/assets/off.png": "bb14",
	"./informatyka/assets/on.png": "f3b8",
	"./informatyka/audio/test.mp3": "6a64",
	"./informatyka/audio/z16c2.mp3": "74af",
	"./informatyka/audio/z27c2.mp3": "55c2",
	"./informatyka/background/strona_000.jpg": "4d7a",
	"./informatyka/background/strona_001.jpg": "9a76",
	"./informatyka/background/strona_002.jpg": "20e8",
	"./informatyka/background/strona_003.jpg": "f2cf",
	"./informatyka/background/strona_004.jpg": "6cc7",
	"./informatyka/background/strona_005.jpg": "8c9a",
	"./informatyka/background/strona_006.jpg": "5d26",
	"./informatyka/background/strona_007.jpg": "b79e",
	"./informatyka/background/strona_008.jpg": "fc6e",
	"./informatyka/background/strona_009.jpg": "99cc",
	"./informatyka/background/strona_010.jpg": "38bf",
	"./informatyka/background/strona_011.jpg": "8b35",
	"./informatyka/background/strona_012.jpg": "c5c6",
	"./informatyka/background/strona_013.jpg": "22fa",
	"./informatyka/background/strona_014.jpg": "6b9a",
	"./informatyka/background/strona_015.jpg": "d056",
	"./informatyka/background/strona_016.jpg": "5588",
	"./informatyka/background/strona_017.jpg": "83d9",
	"./informatyka/background/strona_018.jpg": "8661",
	"./informatyka/background/strona_019.jpg": "c5d7",
	"./informatyka/background/strona_020.jpg": "1d3d",
	"./informatyka/background/strona_021.jpg": "14c0",
	"./informatyka/background/strona_022.jpg": "4a3f",
	"./informatyka/background/strona_023.jpg": "43a1",
	"./informatyka/background/strona_024.jpg": "8de8",
	"./informatyka/background/strona_025.jpg": "fc38",
	"./informatyka/background/strona_026.jpg": "c424",
	"./informatyka/background/strona_027.jpg": "fceb",
	"./informatyka/background/strona_028.jpg": "dc13",
	"./informatyka/background/strona_029.jpg": "bcf9",
	"./informatyka/background/strona_030.jpg": "56d3",
	"./informatyka/background/strona_031.jpg": "fca6",
	"./informatyka/background/strona_032.jpg": "0fd9",
	"./informatyka/background/strona_033.jpg": "6c10",
	"./informatyka/background/strona_034.jpg": "956c",
	"./informatyka/background/strona_035.jpg": "a43a",
	"./informatyka/background/strona_036.jpg": "5da7",
	"./informatyka/background/strona_037.jpg": "d053",
	"./informatyka/background/strona_038.jpg": "06f7",
	"./informatyka/background/strona_039.jpg": "7ade",
	"./informatyka/background/strona_040.jpg": "fa40",
	"./informatyka/background/strona_041.jpg": "abcb",
	"./informatyka/background/strona_042.jpg": "3ca9",
	"./informatyka/background/strona_043.jpg": "b49f",
	"./informatyka/background/strona_044.jpg": "bc07",
	"./informatyka/background/strona_045.jpg": "5c2e",
	"./informatyka/background/strona_046.jpg": "840e",
	"./informatyka/background/strona_047.jpg": "3778",
	"./informatyka/background/strona_048.jpg": "1b1d2",
	"./informatyka/background/strona_049.jpg": "f271",
	"./informatyka/background/strona_050.jpg": "a148",
	"./informatyka/background/strona_051.jpg": "0e12",
	"./informatyka/background/strona_052.jpg": "84cc",
	"./informatyka/background/strona_053.jpg": "af66",
	"./informatyka/background/strona_054.jpg": "39366",
	"./informatyka/background/strona_055.jpg": "6555",
	"./informatyka/background/strona_056.jpg": "48db",
	"./informatyka/background/strona_057.jpg": "0921",
	"./informatyka/background/strona_058.jpg": "18e8",
	"./informatyka/background/strona_059.jpg": "0db6",
	"./informatyka/background/strona_end.jpg": "cf90",
	"./informatyka/background/strona_start.jpg": "00fa",
	"./informatyka/config": "5759",
	"./informatyka/config/": "5759",
	"./informatyka/config/default/config_default": "d7e1",
	"./informatyka/config/default/config_default.js": "d7e1",
	"./informatyka/config/default/test": "1d85",
	"./informatyka/config/default/test.js": "1d85",
	"./informatyka/config/index": "5759",
	"./informatyka/config/index.js": "5759",
	"./informatyka/config/pages": "4585",
	"./informatyka/config/pages/": "4585",
	"./informatyka/config/pages/index": "4585",
	"./informatyka/config/pages/index.js": "4585",
	"./informatyka/config/pages/page000": "5cd0",
	"./informatyka/config/pages/page000.js": "5cd0",
	"./informatyka/config/pages/page001": "816f",
	"./informatyka/config/pages/page001.js": "816f",
	"./informatyka/config/pages/page002": "fac9",
	"./informatyka/config/pages/page002.js": "fac9",
	"./informatyka/config/pages/page003": "678b",
	"./informatyka/config/pages/page003.js": "678b",
	"./informatyka/config/pages/page004": "5fbf",
	"./informatyka/config/pages/page004.js": "5fbf",
	"./informatyka/config/pages/page005": "7b88",
	"./informatyka/config/pages/page005.js": "7b88",
	"./informatyka/config/pages/page006": "43d5",
	"./informatyka/config/pages/page006.js": "43d5",
	"./informatyka/config/pages/page007": "0dc8",
	"./informatyka/config/pages/page007.js": "0dc8",
	"./informatyka/config/pages/page008": "a0fe",
	"./informatyka/config/pages/page008.js": "a0fe",
	"./informatyka/config/pages/page009": "0fc2",
	"./informatyka/config/pages/page009.js": "0fc2",
	"./informatyka/config/pages/page010": "7e47",
	"./informatyka/config/pages/page010.js": "7e47",
	"./informatyka/config/pages/page011": "1c9d",
	"./informatyka/config/pages/page011.js": "1c9d",
	"./informatyka/config/pages/page012": "b2a4",
	"./informatyka/config/pages/page012.js": "b2a4",
	"./informatyka/config/pages/page013": "3b55",
	"./informatyka/config/pages/page013.js": "3b55",
	"./informatyka/config/pages/page014": "7b21",
	"./informatyka/config/pages/page014.js": "7b21",
	"./informatyka/config/pages/page015": "9d7d",
	"./informatyka/config/pages/page015.js": "9d7d",
	"./informatyka/config/pages/page016": "f777",
	"./informatyka/config/pages/page016.js": "f777",
	"./informatyka/config/pages/page017": "09d5",
	"./informatyka/config/pages/page017.js": "09d5",
	"./informatyka/config/pages/page018": "d7cd",
	"./informatyka/config/pages/page018.js": "d7cd",
	"./informatyka/config/pages/page019": "9510",
	"./informatyka/config/pages/page019.js": "9510",
	"./informatyka/config/pages/page020": "2ed6",
	"./informatyka/config/pages/page020.js": "2ed6",
	"./informatyka/config/pages/page021": "d21e",
	"./informatyka/config/pages/page021.js": "d21e",
	"./informatyka/config/pages/page022": "e891",
	"./informatyka/config/pages/page022.js": "e891",
	"./informatyka/config/pages/page023": "c311",
	"./informatyka/config/pages/page023.js": "c311",
	"./informatyka/config/pages/page024": "3983",
	"./informatyka/config/pages/page024.js": "3983",
	"./informatyka/config/pages/page025": "1cdc",
	"./informatyka/config/pages/page025.js": "1cdc",
	"./informatyka/config/pages/page026": "7896",
	"./informatyka/config/pages/page026.js": "7896",
	"./informatyka/config/pages/page027": "4e35",
	"./informatyka/config/pages/page027.js": "4e35",
	"./informatyka/config/pages/page028": "c3c6",
	"./informatyka/config/pages/page028.js": "c3c6",
	"./informatyka/config/pages/page029": "118f",
	"./informatyka/config/pages/page029.js": "118f",
	"./informatyka/config/pages/page030": "e7f8",
	"./informatyka/config/pages/page030.js": "e7f8",
	"./informatyka/config/pages/page031": "fd8f",
	"./informatyka/config/pages/page031.js": "fd8f",
	"./informatyka/config/pages/page032": "fd9b",
	"./informatyka/config/pages/page032.js": "fd9b",
	"./informatyka/config/pages/page033": "5396",
	"./informatyka/config/pages/page033.js": "5396",
	"./informatyka/config/pages/page034": "9d5a",
	"./informatyka/config/pages/page034.js": "9d5a",
	"./informatyka/config/pages/page035": "f36c",
	"./informatyka/config/pages/page035.js": "f36c",
	"./informatyka/config/pages/page036": "f19c",
	"./informatyka/config/pages/page036.js": "f19c",
	"./informatyka/config/pages/page037": "b973",
	"./informatyka/config/pages/page037.js": "b973",
	"./informatyka/config/pages/page038": "720c",
	"./informatyka/config/pages/page038.js": "720c",
	"./informatyka/config/pages/page039": "9832",
	"./informatyka/config/pages/page039.js": "9832",
	"./informatyka/config/pages/page040": "999b",
	"./informatyka/config/pages/page040.js": "999b",
	"./informatyka/config/pages/page041": "5638",
	"./informatyka/config/pages/page041.js": "5638",
	"./informatyka/config/pages/page042": "9605",
	"./informatyka/config/pages/page042.js": "9605",
	"./informatyka/config/pages/page043": "8ace",
	"./informatyka/config/pages/page043.js": "8ace",
	"./informatyka/config/pages/page044": "1b1d",
	"./informatyka/config/pages/page044.js": "1b1d",
	"./informatyka/config/pages/page045": "ae9a",
	"./informatyka/config/pages/page045.js": "ae9a",
	"./informatyka/config/pages/page046": "eb84",
	"./informatyka/config/pages/page046.js": "eb84",
	"./informatyka/config/pages/page047": "8c78",
	"./informatyka/config/pages/page047.js": "8c78",
	"./informatyka/config/pages/page048": "1119",
	"./informatyka/config/pages/page048.js": "1119",
	"./informatyka/config/pages/page049": "7e31",
	"./informatyka/config/pages/page049.js": "7e31",
	"./informatyka/config/pages/page050": "0657",
	"./informatyka/config/pages/page050.js": "0657",
	"./informatyka/config/pages/page051": "353e",
	"./informatyka/config/pages/page051.js": "353e",
	"./informatyka/config/pages/page052": "58cf",
	"./informatyka/config/pages/page052.js": "58cf",
	"./informatyka/config/pages/page053": "204c",
	"./informatyka/config/pages/page053.js": "204c",
	"./informatyka/config/pages/page054": "cc87",
	"./informatyka/config/pages/page054.js": "cc87",
	"./informatyka/config/pages/page055": "efb3",
	"./informatyka/config/pages/page055.js": "efb3",
	"./informatyka/config/pages/page056": "2f2a",
	"./informatyka/config/pages/page056.js": "2f2a",
	"./informatyka/config/pages/page057": "0ecc",
	"./informatyka/config/pages/page057.js": "0ecc",
	"./informatyka/config/pages/page058": "5f69",
	"./informatyka/config/pages/page058.js": "5f69",
	"./informatyka/config/pages/page059": "160a",
	"./informatyka/config/pages/page059.js": "160a",
	"./informatyka/config/pages/pageEnd": "04fb",
	"./informatyka/config/pages/pageEnd.js": "04fb",
	"./informatyka/config/pages/pageStart": "6fb3",
	"./informatyka/config/pages/pageStart.js": "6fb3",
	"./informatyka/config/subconfig": "76f2",
	"./informatyka/config/subconfig.js": "76f2",
	"./informatyka/files/page000/1.2D_excel-kasowanie.xlsx": "e522",
	"./informatyka/files/page000/2.7B_WORD.doc": "1155",
	"./informatyka/files/page000/link1D_word-zawod.docx": "c976",
	"./informatyka/files/page000/link1E_prezentacja-zawod.pptx": "9b3e",
	"./informatyka/files/page000/link2B_paint-pusty.bmp": "ed95",
	"./informatyka/files/page003/1.jpg": "bd8a",
	"./informatyka/files/page003/EI_kl.1_z.17cw.3.tif": "c0d2",
	"./informatyka/files/page003/z.3cw.3.bmp": "f312",
	"./informatyka/files/page003/z3c3.mp3": "f435",
	"./informatyka/files/page004/z.4cw.1.bmp": "93c0",
	"./informatyka/files/page004/z.4cw.2.bmp": "a495",
	"./informatyka/files/page004/z.4cw.3.bmp": "045a",
	"./informatyka/files/page004/z4c1.mp3": "a7fa",
	"./informatyka/files/page004/z4c2.mp3": "56b1",
	"./informatyka/files/page004/z4c3.mp3": "319f",
	"./informatyka/files/page005/z.5cw.2.bmp": "f093",
	"./informatyka/files/page005/z.5cw.3.bmp": "71d3",
	"./informatyka/files/page005/z5c2.mp3": "deb3",
	"./informatyka/files/page005/z5c3.mp3": "5330",
	"./informatyka/files/page005/z5c3o.mp3": "c471",
	"./informatyka/files/page006/z.6cw.4.bmp": "8b04",
	"./informatyka/files/page006/z6c4.mp3": "4552",
	"./informatyka/files/page008/z.8cw.2.bmp": "24e9",
	"./informatyka/files/page008/z.8cw.3.bmp": "f5b24",
	"./informatyka/files/page008/z.8cw.4.bmp": "c0d4",
	"./informatyka/files/page008/z8c2.mp3": "ed4e",
	"./informatyka/files/page008/z8c3.mp3": "c0bc",
	"./informatyka/files/page008/z8c4.mp3": "dfa9",
	"./informatyka/files/page009/z.9cw.1.bmp": "643a",
	"./informatyka/files/page009/z.9cw.2.bmp": "7dfe",
	"./informatyka/files/page009/z.9cw.3.bmp": "bdab",
	"./informatyka/files/page009/z9c1.mp3": "8bcf",
	"./informatyka/files/page009/z9c2.mp3": "b689",
	"./informatyka/files/page009/z9c3.mp3": "9220",
	"./informatyka/files/page010/z.10cw.2.bmp": "0aa9",
	"./informatyka/files/page010/z.10cw.3.bmp": "23a6",
	"./informatyka/files/page010/z10c2.mp3": "0b2d",
	"./informatyka/files/page010/z10c3.mp3": "ea41",
	"./informatyka/files/page011/z.11cw.1.bmp": "602d",
	"./informatyka/files/page011/z.11cw.2.bmp": "fece",
	"./informatyka/files/page011/z11c1.mp3": "ab56",
	"./informatyka/files/page011/z11c2.mp3": "0d5a",
	"./informatyka/files/page012/z.12cw.2.bmp": "ded9",
	"./informatyka/files/page012/z.12cw.3.bmp": "9820",
	"./informatyka/files/page012/z12c2.mp3": "53c0",
	"./informatyka/files/page012/z12c3.mp3": "d772",
	"./informatyka/files/page013/z.13cw.1.bmp": "5772",
	"./informatyka/files/page013/z.13cw.2.bmp": "2f26",
	"./informatyka/files/page013/z.13cw.3.bmp": "8511",
	"./informatyka/files/page013/z13c1.mp3": "631e",
	"./informatyka/files/page013/z13c2.mp3": "2d8e",
	"./informatyka/files/page013/z13c3.mp3": "3a79",
	"./informatyka/files/page014/z.14cw.1.bmp": "012c",
	"./informatyka/files/page014/z.14cw.2.bmp": "9cff",
	"./informatyka/files/page014/z.14cw.3.bmp": "84d4",
	"./informatyka/files/page014/z14c1.mp3": "744c",
	"./informatyka/files/page014/z14c2.mp3": "5961",
	"./informatyka/files/page014/z14c3.mp3": "7828",
	"./informatyka/files/page015/z.15cw.1.bmp": "af49",
	"./informatyka/files/page015/z.15cw.2.bmp": "badb",
	"./informatyka/files/page015/z.15cw.3.bmp": "87ea",
	"./informatyka/files/page015/z.15cw.3b.bmp": "f4f8",
	"./informatyka/files/page015/z.15cw.4.bmp": "0fa07",
	"./informatyka/files/page015/z15c1.mp3": "ad23",
	"./informatyka/files/page015/z15c2.mp3": "6fbb",
	"./informatyka/files/page015/z15c3.mp3": "822b",
	"./informatyka/files/page015/z15c3b.mp3": "e3e8",
	"./informatyka/files/page015/z15c4.mp3": "68a0",
	"./informatyka/files/page016/z.16cw.3.bmp": "5119",
	"./informatyka/files/page016/z16c3.mp3": "3dda",
	"./informatyka/files/page017/z.17cw.3.bmp": "69fd8",
	"./informatyka/files/page017/z17c3.mp3": "8592",
	"./informatyka/files/page018/z.18cw.2.bmp": "49c4",
	"./informatyka/files/page018/z.18cw.3.bmp": "58c5",
	"./informatyka/files/page018/z18c2.mp3": "68d9",
	"./informatyka/files/page018/z18c3.mp3": "eba2",
	"./informatyka/files/page019/z.19cw.2.bmp": "9a6d",
	"./informatyka/files/page019/z19c2.mp3": "4b70",
	"./informatyka/files/page021/21_ćw_1_word.docx": "cdc7",
	"./informatyka/files/page021/21_ćw_2_word.docx": "8e25",
	"./informatyka/files/page021/21_ćw_3_word.docx": "37758",
	"./informatyka/files/page021/z21c1.mp3": "cd62",
	"./informatyka/files/page021/z21c2.mp3": "0b61",
	"./informatyka/files/page021/z21c3.mp3": "e29d",
	"./informatyka/files/page022/22_ćw_2_word.docx": "e727",
	"./informatyka/files/page022/z22c2.mp3": "2b9a",
	"./informatyka/files/page023/23_ćw_2_word.docx": "121d",
	"./informatyka/files/page023/23_ćw_3_word.docx": "3af4",
	"./informatyka/files/page023/z23c2.mp3": "3154",
	"./informatyka/files/page023/z23c3.mp3": "d1f1",
	"./informatyka/files/page024/24_ćw_2_word.docx": "a3cd",
	"./informatyka/files/page024/z.24cw.3.bmp": "198d",
	"./informatyka/files/page024/z24c2.mp3": "f42b",
	"./informatyka/files/page024/z24c3.mp3": "4cc5",
	"./informatyka/files/page024/z24c4 - Stereo Out.mp3": "11d5",
	"./informatyka/files/page025/z.25cw.2.bmp": "70b4",
	"./informatyka/files/page025/z.25cw.3.bmp": "f3f3",
	"./informatyka/files/page025/z25c2.mp3": "20b8",
	"./informatyka/files/page025/z25c3.mp3": "7563",
	"./informatyka/files/page026/26_ćw_3_word.docx": "9ed8",
	"./informatyka/files/page026/z.26cw.2.bmp": "a0de",
	"./informatyka/files/page026/z26c2.mp3": "77e7",
	"./informatyka/files/page026/z26c3.mp3": "db28",
	"./informatyka/files/page027/z.27cw.3.bmp": "acee",
	"./informatyka/files/page027/z27c3.mp3": "ac3c",
	"./informatyka/files/page032/55862_0_basnie-rysunki konturowe il1_original2.png": "2768",
	"./informatyka/files/page032/55862_0_basnie-rysunki konturowe il2_original2.png": "8c2a",
	"./informatyka/files/page032/55862_0_basnie-rysunki konturowe il3_original2.png": "b475",
	"./informatyka/files/page054/56969_0_dzieci na plazy_original127.png": "88b0",
	"./informatyka/files/page054/56970_0_dziecko z psem gory_original115.png": "c2f4",
	"./informatyka/films/base.png": "2a7c",
	"./informatyka/gallery/page025/001.jpg": "09b8",
	"./informatyka/gallery/page025/002.jpg": "c8ca",
	"./informatyka/gallery/page025/003.jpg": "412a",
	"./informatyka/gallery/page025/004.jpg": "4f85",
	"./informatyka/gallery/page025/005.jpg": "09a2",
	"./informatyka/gallery/page025/006.jpg": "798a",
	"./informatyka/gallery/page025/007.jpg": "4781",
	"./informatyka/gallery/page025/008.jpg": "d57c",
	"./informatyka/gallery/page025/009.jpg": "4d8f",
	"./informatyka/gallery/page025/010.jpg": "3c97",
	"./informatyka/gallery/page025/011.jpg": "bba9",
	"./informatyka/gallery/page025/012.jpg": "b191",
	"./informatyka/gallery/page025/013.jpg": "6850",
	"./informatyka/gallery/page025/014.jpg": "8b17",
	"./informatyka/gallery/page025/015.jpg": "045d",
	"./informatyka/gallery/page025/016.jpg": "804f",
	"./informatyka/gallery/page025/017.jpg": "eb4e",
	"./informatyka/gallery/page025/018.jpg": "14e9",
	"./informatyka/gallery/page025/019.jpg": "d999",
	"./informatyka/gallery/page025/020.jpg": "38f2",
	"./informatyka/gallery/page032/001.jpg": "a161",
	"./informatyka/gallery/page032/002.jpg": "31f7",
	"./informatyka/gallery/page032/003.jpg": "5dcd",
	"./informatyka/gallery/page032/004.jpg": "aa00",
	"./informatyka/gallery/page032/005.jpg": "dd6c",
	"./informatyka/gallery/page032/006.jpg": "5ea8",
	"./informatyka/gallery/page032/007.jpg": "463d",
	"./informatyka/gallery/page032/008.jpg": "76374",
	"./informatyka/gallery/page032/009.jpg": "3650",
	"./informatyka/gallery/page032/010.jpg": "c00e",
	"./informatyka/gallery/page032/011.jpg": "93ba",
	"./informatyka/gallery/page032/012.jpg": "b02c",
	"./informatyka/gallery/page032/013.jpg": "d532",
	"./informatyka/gallery/page032/014.jpg": "43d7",
	"./informatyka/gallery/page032/015.jpg": "88c3",
	"./informatyka/gallery/page032/016.jpg": "094b",
	"./informatyka/gallery/page032/017.jpg": "e4ea",
	"./informatyka/gallery/page032/018.jpg": "faef",
	"./informatyka/gallery/page032/019.jpg": "f376",
	"./informatyka/gallery/page032/020.jpg": "486f",
	"./informatyka/gallery/page032/021.jpg": "ac8b",
	"./informatyka/gallery/page032/022.jpg": "7026",
	"./informatyka/gallery/page032/023.jpg": "62c6",
	"./informatyka/gallery/page032/024.jpg": "998e",
	"./informatyka/gallery/page032/025.jpg": "341d",
	"./informatyka/gallery/page032/026.jpg": "4378",
	"./informatyka/gallery/page032/027.jpg": "d590",
	"./informatyka/gallery/page032/028.jpg": "9e26",
	"./informatyka/gallery/page032/029.jpg": "7b2f",
	"./informatyka/gallery/page032/030.jpg": "8eaf",
	"./informatyka/games": "5c9a",
	"./informatyka/games/": "5c9a",
	"./informatyka/games/04.png": "a530",
	"./informatyka/games/index": "5c9a",
	"./informatyka/games/index.js": "5c9a",
	"./informatyka/games/page001_game1/audio": "cb7f",
	"./informatyka/games/page001_game1/audio/": "cb7f",
	"./informatyka/games/page001_game1/audio/index": "cb7f",
	"./informatyka/games/page001_game1/audio/index.js": "cb7f",
	"./informatyka/games/page001_game1/audio/test.mp3": "8c62",
	"./informatyka/games/page001_game1/audio/z1c1-1.mp3": "29aa",
	"./informatyka/games/page001_game1/audio/z1c1-2.mp3": "2170",
	"./informatyka/games/page001_game1/audio/z1c1-3.mp3": "b2bf",
	"./informatyka/games/page001_game1/audio/z1c1-4.mp3": "e032",
	"./informatyka/games/page001_game1/audio/z1c1-5.mp3": "f3bc",
	"./informatyka/games/page001_game1/audio/z1c1-6.mp3": "be9e",
	"./informatyka/games/page001_game1/audio/z1c1-brawo.mp3": "f6ea",
	"./informatyka/games/page001_game1/audio/z1c1-polecenie.mp3": "5801",
	"./informatyka/games/page001_game1/audio/z1c1_1.mp3": "11fa",
	"./informatyka/games/page001_game1/config": "0fd2",
	"./informatyka/games/page001_game1/config.js": "0fd2",
	"./informatyka/games/page001_game1/gameData.config": "e7fc",
	"./informatyka/games/page001_game1/gameData.config.js": "e7fc",
	"./informatyka/games/page001_game1/img": "acef",
	"./informatyka/games/page001_game1/img/": "acef",
	"./informatyka/games/page001_game1/img/00.png": "5d01",
	"./informatyka/games/page001_game1/img/01.png": "f635",
	"./informatyka/games/page001_game1/img/02.png": "7bd0",
	"./informatyka/games/page001_game1/img/10.png": "5aa6",
	"./informatyka/games/page001_game1/img/11.png": "dfaf",
	"./informatyka/games/page001_game1/img/bcg.png": "eb7e",
	"./informatyka/games/page001_game1/img/des.png": "6ee6",
	"./informatyka/games/page001_game1/img/index": "acef",
	"./informatyka/games/page001_game1/img/index.js": "acef",
	"./informatyka/games/page001_game2/audio": "43b7",
	"./informatyka/games/page001_game2/audio/": "43b7",
	"./informatyka/games/page001_game2/audio/fls.mp3": "fa52",
	"./informatyka/games/page001_game2/audio/index": "43b7",
	"./informatyka/games/page001_game2/audio/index.js": "43b7",
	"./informatyka/games/page001_game2/audio/tru.mp3": "1709",
	"./informatyka/games/page001_game2/audio/z1c2.mp3": "3a89",
	"./informatyka/games/page001_game2/config": "8c82",
	"./informatyka/games/page001_game2/config.js": "8c82",
	"./informatyka/games/page001_game2/gameData.config": "5d42",
	"./informatyka/games/page001_game2/gameData.config.js": "5d42",
	"./informatyka/games/page001_game2/img": "9518",
	"./informatyka/games/page001_game2/img/": "9518",
	"./informatyka/games/page001_game2/img/bcg.png": "6c80",
	"./informatyka/games/page001_game2/img/false.png": "3806",
	"./informatyka/games/page001_game2/img/index": "9518",
	"./informatyka/games/page001_game2/img/index.js": "9518",
	"./informatyka/games/page001_game2/img/true.png": "b924",
	"./informatyka/games/page001_game3/audio": "93b1",
	"./informatyka/games/page001_game3/audio/": "93b1",
	"./informatyka/games/page001_game3/audio/index": "93b1",
	"./informatyka/games/page001_game3/audio/index.js": "93b1",
	"./informatyka/games/page001_game3/audio/z1c3-1.mp3": "b359",
	"./informatyka/games/page001_game3/audio/z1c3-2.mp3": "bf82",
	"./informatyka/games/page001_game3/audio/z1c3-3.mp3": "7730",
	"./informatyka/games/page001_game3/audio/z1c3-4.mp3": "499b",
	"./informatyka/games/page001_game3/audio/z1c3-polecenie.mp3": "f25f",
	"./informatyka/games/page001_game3/config": "caa3",
	"./informatyka/games/page001_game3/config.js": "caa3",
	"./informatyka/games/page001_game3/gameData.config": "d601",
	"./informatyka/games/page001_game3/gameData.config.js": "d601",
	"./informatyka/games/page001_game3/img": "e94c",
	"./informatyka/games/page001_game3/img/": "e94c",
	"./informatyka/games/page001_game3/img/bcg.jpg": "03bf",
	"./informatyka/games/page001_game3/img/dzwiek.png": "a59e",
	"./informatyka/games/page001_game3/img/index": "e94c",
	"./informatyka/games/page001_game3/img/index.js": "e94c",
	"./informatyka/games/page002_game0/audio": "3c0e",
	"./informatyka/games/page002_game0/audio/": "3c0e",
	"./informatyka/games/page002_game0/audio/index": "3c0e",
	"./informatyka/games/page002_game0/audio/index.js": "3c0e",
	"./informatyka/games/page002_game0/audio/klik.mp3": "fc91",
	"./informatyka/games/page002_game0/audio/z2c3.mp3": "b0ff",
	"./informatyka/games/page002_game0/audio/z2c3brawo.mp3": "a322",
	"./informatyka/games/page002_game0/config": "6108",
	"./informatyka/games/page002_game0/config.js": "6108",
	"./informatyka/games/page002_game0/gameData.config": "9de9",
	"./informatyka/games/page002_game0/gameData.config.js": "9de9",
	"./informatyka/games/page002_game0/img": "962e",
	"./informatyka/games/page002_game0/img/": "962e",
	"./informatyka/games/page002_game0/img/bb.png": "9e71",
	"./informatyka/games/page002_game0/img/bcg.png": "923e",
	"./informatyka/games/page002_game0/img/dron.png": "2ed93",
	"./informatyka/games/page002_game0/img/index": "962e",
	"./informatyka/games/page002_game0/img/index.js": "962e",
	"./informatyka/games/page002_game0/img/komp.png": "9891",
	"./informatyka/games/page002_game0/img/laptop.png": "def6",
	"./informatyka/games/page002_game0/img/smartwatch.png": "101b",
	"./informatyka/games/page002_game0/img/statusCorrect.png": "ddd2",
	"./informatyka/games/page002_game0/img/tablet.png": "7c3c",
	"./informatyka/games/page002_game1/audio": "c6db",
	"./informatyka/games/page002_game1/audio/": "c6db",
	"./informatyka/games/page002_game1/audio/index": "c6db",
	"./informatyka/games/page002_game1/audio/index.js": "c6db",
	"./informatyka/games/page002_game1/audio/z2c1-1.mp3": "56ba",
	"./informatyka/games/page002_game1/audio/z2c1-2.mp3": "6252",
	"./informatyka/games/page002_game1/audio/z2c1-3.mp3": "e279",
	"./informatyka/games/page002_game1/audio/z2c1-4.mp3": "4c0d",
	"./informatyka/games/page002_game1/audio/z2c1-polecenie.mp3": "06b8",
	"./informatyka/games/page002_game1/config": "31be",
	"./informatyka/games/page002_game1/config.js": "31be",
	"./informatyka/games/page002_game1/gameData.config": "ef3c",
	"./informatyka/games/page002_game1/gameData.config.js": "ef3c",
	"./informatyka/games/page002_game1/img": "8e04",
	"./informatyka/games/page002_game1/img/": "8e04",
	"./informatyka/games/page002_game1/img/bcg.jpg": "f7a9",
	"./informatyka/games/page002_game1/img/dzwiek.png": "09ed",
	"./informatyka/games/page002_game1/img/index": "8e04",
	"./informatyka/games/page002_game1/img/index.js": "8e04",
	"./informatyka/games/page002_game2/audio": "8d96",
	"./informatyka/games/page002_game2/audio/": "8d96",
	"./informatyka/games/page002_game2/audio/f.mp3": "b860",
	"./informatyka/games/page002_game2/audio/index": "8d96",
	"./informatyka/games/page002_game2/audio/index.js": "8d96",
	"./informatyka/games/page002_game2/audio/t.mp3": "d82d",
	"./informatyka/games/page002_game2/audio/true.mp3": "3f87",
	"./informatyka/games/page002_game2/audio/z2c2.mp3": "b144",
	"./informatyka/games/page002_game2/audio/z2c2brawo.mp3": "6b5c",
	"./informatyka/games/page002_game2/config": "0968",
	"./informatyka/games/page002_game2/config.js": "0968",
	"./informatyka/games/page002_game2/gameData.config": "e79f",
	"./informatyka/games/page002_game2/gameData.config.js": "e79f",
	"./informatyka/games/page002_game2/img": "79d3",
	"./informatyka/games/page002_game2/img/": "79d3",
	"./informatyka/games/page002_game2/img/00.png": "206c",
	"./informatyka/games/page002_game2/img/01.png": "478c",
	"./informatyka/games/page002_game2/img/02.png": "520b",
	"./informatyka/games/page002_game2/img/03.png": "99d3",
	"./informatyka/games/page002_game2/img/bcg.png": "5332",
	"./informatyka/games/page002_game2/img/des.jpg": "bd0b",
	"./informatyka/games/page002_game2/img/des.png": "fdc7",
	"./informatyka/games/page002_game2/img/index": "79d3",
	"./informatyka/games/page002_game2/img/index.js": "79d3",
	"./informatyka/games/page002_game3/audio": "4ee1",
	"./informatyka/games/page002_game3/audio/": "4ee1",
	"./informatyka/games/page002_game3/audio/index": "4ee1",
	"./informatyka/games/page002_game3/audio/index.js": "4ee1",
	"./informatyka/games/page002_game3/audio/klik.mp3": "22bc",
	"./informatyka/games/page002_game3/audio/z2c3.mp3": "2ef05",
	"./informatyka/games/page002_game3/audio/z2c3brawo.mp3": "f212",
	"./informatyka/games/page002_game3/config": "ac33",
	"./informatyka/games/page002_game3/config.js": "ac33",
	"./informatyka/games/page002_game3/gameData.config": "0e64",
	"./informatyka/games/page002_game3/gameData.config.js": "0e64",
	"./informatyka/games/page002_game3/img": "0fc6",
	"./informatyka/games/page002_game3/img/": "0fc6",
	"./informatyka/games/page002_game3/img/bgr.jpg": "e233",
	"./informatyka/games/page002_game3/img/dron.png": "47d0",
	"./informatyka/games/page002_game3/img/index": "0fc6",
	"./informatyka/games/page002_game3/img/index.js": "0fc6",
	"./informatyka/games/page002_game3/img/komp.png": "8dc4",
	"./informatyka/games/page002_game3/img/laptop.png": "b778",
	"./informatyka/games/page002_game3/img/select.png": "05c3",
	"./informatyka/games/page002_game3/img/smartwatch.png": "7453",
	"./informatyka/games/page002_game3/img/tablet.png": "8dde",
	"./informatyka/games/page002_game4/audio": "a793",
	"./informatyka/games/page002_game4/audio/": "a793",
	"./informatyka/games/page002_game4/audio/index": "a793",
	"./informatyka/games/page002_game4/audio/index.js": "a793",
	"./informatyka/games/page002_game4/audio/z2c4.mp3": "7805",
	"./informatyka/games/page002_game4/config": "5ad2",
	"./informatyka/games/page002_game4/config.js": "5ad2",
	"./informatyka/games/page002_game4/gameData.config": "8ba8",
	"./informatyka/games/page002_game4/gameData.config.js": "8ba8",
	"./informatyka/games/page002_game4/img": "3f76",
	"./informatyka/games/page002_game4/img/": "3f76",
	"./informatyka/games/page002_game4/img/i4.png": "a9ba",
	"./informatyka/games/page002_game4/img/i5.png": "5efa",
	"./informatyka/games/page002_game4/img/index": "3f76",
	"./informatyka/games/page002_game4/img/index.js": "3f76",
	"./informatyka/games/page002_game5/audio": "1ec4",
	"./informatyka/games/page002_game5/audio/": "1ec4",
	"./informatyka/games/page002_game5/audio/index": "1ec4",
	"./informatyka/games/page002_game5/audio/index.js": "1ec4",
	"./informatyka/games/page002_game5/audio/test.mp3": "8ec6",
	"./informatyka/games/page002_game5/audio/z2c5-1.mp3": "cc60",
	"./informatyka/games/page002_game5/audio/z2c5-2.mp3": "6d5b",
	"./informatyka/games/page002_game5/audio/z2c5-3.mp3": "17df",
	"./informatyka/games/page002_game5/audio/z2c5-4.mp3": "d8f3",
	"./informatyka/games/page002_game5/audio/z2c5-5.mp3": "cbf9",
	"./informatyka/games/page002_game5/audio/z2c5-6.mp3": "b0d8",
	"./informatyka/games/page002_game5/audio/z2c5-brawo.mp3": "f681",
	"./informatyka/games/page002_game5/audio/z2c5polecenie.mp3": "215d",
	"./informatyka/games/page002_game5/config": "3e65",
	"./informatyka/games/page002_game5/config.js": "3e65",
	"./informatyka/games/page002_game5/gameData.config": "0ca0",
	"./informatyka/games/page002_game5/gameData.config.js": "0ca0",
	"./informatyka/games/page002_game5/img": "3191",
	"./informatyka/games/page002_game5/img/": "3191",
	"./informatyka/games/page002_game5/img/01.png": "f6f7",
	"./informatyka/games/page002_game5/img/02.png": "8ea6",
	"./informatyka/games/page002_game5/img/03.png": "b6b6",
	"./informatyka/games/page002_game5/img/04.png": "0273",
	"./informatyka/games/page002_game5/img/05.png": "51f6",
	"./informatyka/games/page002_game5/img/06.png": "0131",
	"./informatyka/games/page002_game5/img/index": "3191",
	"./informatyka/games/page002_game5/img/index.js": "3191",
	"./informatyka/games/page002_game5/img/tru.png": "2266",
	"./informatyka/games/page002_game5/img/war.png": "a4c5",
	"./informatyka/games/page003_game1/audio": "2c5e",
	"./informatyka/games/page003_game1/audio/": "2c5e",
	"./informatyka/games/page003_game1/audio/index": "2c5e",
	"./informatyka/games/page003_game1/audio/index.js": "2c5e",
	"./informatyka/games/page003_game1/audio/klik.mp3": "cee3",
	"./informatyka/games/page003_game1/audio/z3c1-brawo.mp3": "bfb4",
	"./informatyka/games/page003_game1/audio/z3c1-polecenie.mp3": "7e26",
	"./informatyka/games/page003_game1/config": "c54e",
	"./informatyka/games/page003_game1/config.js": "c54e",
	"./informatyka/games/page003_game1/gameData.config": "7167",
	"./informatyka/games/page003_game1/gameData.config.js": "7167",
	"./informatyka/games/page003_game1/img": "5475",
	"./informatyka/games/page003_game1/img/": "5475",
	"./informatyka/games/page003_game1/img/00.png": "89c2",
	"./informatyka/games/page003_game1/img/01.png": "b90f",
	"./informatyka/games/page003_game1/img/02.png": "0a10",
	"./informatyka/games/page003_game1/img/03.png": "6ab6",
	"./informatyka/games/page003_game1/img/04.png": "b7d0",
	"./informatyka/games/page003_game1/img/05.png": "d546",
	"./informatyka/games/page003_game1/img/index": "5475",
	"./informatyka/games/page003_game1/img/index.js": "5475",
	"./informatyka/games/page003_game1/img/target.png": "5f25",
	"./informatyka/games/page003_game2/audio": "e642",
	"./informatyka/games/page003_game2/audio/": "e642",
	"./informatyka/games/page003_game2/audio/index": "e642",
	"./informatyka/games/page003_game2/audio/index.js": "e642",
	"./informatyka/games/page003_game2/audio/z3c2.mp3": "1ece",
	"./informatyka/games/page003_game2/config": "e05f",
	"./informatyka/games/page003_game2/config.js": "e05f",
	"./informatyka/games/page003_game2/gameData.config": "a56c",
	"./informatyka/games/page003_game2/gameData.config.js": "a56c",
	"./informatyka/games/page003_game2/img": "5f27",
	"./informatyka/games/page003_game2/img/": "5f27",
	"./informatyka/games/page003_game2/img/55817_0_dziecko ze smartfonem25.png": "4e65",
	"./informatyka/games/page003_game2/img/55817_0_dziecko ze smartfonem25_out.png": "89ae",
	"./informatyka/games/page003_game2/img/55817_0_dziecko ze smartfonem_tr.png": "6a62",
	"./informatyka/games/page003_game2/img/index": "5f27",
	"./informatyka/games/page003_game2/img/index.js": "5f27",
	"./informatyka/games/page003_game2/img/paleta_raster.png": "c294",
	"./informatyka/games/page003_game4/audio": "b25d",
	"./informatyka/games/page003_game4/audio/": "b25d",
	"./informatyka/games/page003_game4/audio/index": "b25d",
	"./informatyka/games/page003_game4/audio/index.js": "b25d",
	"./informatyka/games/page003_game4/audio/klik.mp3": "ffe8",
	"./informatyka/games/page003_game4/audio/z3c4-brawo.mp3": "c1cf",
	"./informatyka/games/page003_game4/audio/z3c4.mp3": "c9c4",
	"./informatyka/games/page003_game4/config": "ad56",
	"./informatyka/games/page003_game4/config.js": "ad56",
	"./informatyka/games/page003_game4/gameData.config": "747d",
	"./informatyka/games/page003_game4/gameData.config.js": "747d",
	"./informatyka/games/page003_game4/img": "f0bc",
	"./informatyka/games/page003_game4/img/": "f0bc",
	"./informatyka/games/page003_game4/img/00.png": "cb3f",
	"./informatyka/games/page003_game4/img/01.png": "3707",
	"./informatyka/games/page003_game4/img/02.png": "312e",
	"./informatyka/games/page003_game4/img/03.png": "cfc9",
	"./informatyka/games/page003_game4/img/04.png": "4282",
	"./informatyka/games/page003_game4/img/05.png": "363c",
	"./informatyka/games/page003_game4/img/bgr.png": "2b3f",
	"./informatyka/games/page003_game4/img/index": "f0bc",
	"./informatyka/games/page003_game4/img/index.js": "f0bc",
	"./informatyka/games/page004_game4/audio": "7ff0",
	"./informatyka/games/page004_game4/audio/": "7ff0",
	"./informatyka/games/page004_game4/audio/index": "7ff0",
	"./informatyka/games/page004_game4/audio/index.js": "7ff0",
	"./informatyka/games/page004_game4/audio/z4c3.mp3": "1e0e",
	"./informatyka/games/page004_game4/config": "2cb3",
	"./informatyka/games/page004_game4/config.js": "2cb3",
	"./informatyka/games/page004_game4/gameData.config": "ebba",
	"./informatyka/games/page004_game4/gameData.config.js": "ebba",
	"./informatyka/games/page004_game4/img": "1924",
	"./informatyka/games/page004_game4/img/": "1924",
	"./informatyka/games/page004_game4/img/bcg.png": "edf8",
	"./informatyka/games/page004_game4/img/index": "1924",
	"./informatyka/games/page004_game4/img/index.js": "1924",
	"./informatyka/games/page005_game1/audio": "cf8e",
	"./informatyka/games/page005_game1/audio/": "cf8e",
	"./informatyka/games/page005_game1/audio/index": "cf8e",
	"./informatyka/games/page005_game1/audio/index.js": "cf8e",
	"./informatyka/games/page005_game1/audio/z5c1-brawo.mp3": "2520",
	"./informatyka/games/page005_game1/audio/z5c1.mp3": "2617",
	"./informatyka/games/page005_game1/config": "3851",
	"./informatyka/games/page005_game1/config.js": "3851",
	"./informatyka/games/page005_game1/gameData.config": "4d69",
	"./informatyka/games/page005_game1/gameData.config.js": "4d69",
	"./informatyka/games/page005_game1/img": "dc97",
	"./informatyka/games/page005_game1/img/": "dc97",
	"./informatyka/games/page005_game1/img/00.png": "0dc6",
	"./informatyka/games/page005_game1/img/01.png": "11d2",
	"./informatyka/games/page005_game1/img/02.png": "0e02",
	"./informatyka/games/page005_game1/img/03.png": "7441",
	"./informatyka/games/page005_game1/img/04.png": "48d5",
	"./informatyka/games/page005_game1/img/index": "dc97",
	"./informatyka/games/page005_game1/img/index.js": "dc97",
	"./informatyka/games/page005_game1/img/uruchomPaint_okno_5.png": "ba7b",
	"./informatyka/games/page006_game1/audio": "037b",
	"./informatyka/games/page006_game1/audio/": "037b",
	"./informatyka/games/page006_game1/audio/index": "037b",
	"./informatyka/games/page006_game1/audio/index.js": "037b",
	"./informatyka/games/page006_game1/audio/z6c1-1.mp3": "d101",
	"./informatyka/games/page006_game1/audio/z6c1-brawo.mp3": "7c29",
	"./informatyka/games/page006_game1/config": "bbf9",
	"./informatyka/games/page006_game1/config.js": "bbf9",
	"./informatyka/games/page006_game1/gameData.config": "f525",
	"./informatyka/games/page006_game1/gameData.config.js": "f525",
	"./informatyka/games/page006_game1/img": "8dec",
	"./informatyka/games/page006_game1/img/": "8dec",
	"./informatyka/games/page006_game1/img/00.png": "0c34",
	"./informatyka/games/page006_game1/img/01.png": "4355",
	"./informatyka/games/page006_game1/img/02.png": "3706",
	"./informatyka/games/page006_game1/img/03.png": "7997",
	"./informatyka/games/page006_game1/img/04.png": "22a4",
	"./informatyka/games/page006_game1/img/05.png": "7e99",
	"./informatyka/games/page006_game1/img/06.png": "92bb",
	"./informatyka/games/page006_game1/img/07.png": "bc01",
	"./informatyka/games/page006_game1/img/bgr.png": "f1fc",
	"./informatyka/games/page006_game1/img/hook.png": "d4ba",
	"./informatyka/games/page006_game1/img/index": "8dec",
	"./informatyka/games/page006_game1/img/index.js": "8dec",
	"./informatyka/games/page006_game11/audio": "089f",
	"./informatyka/games/page006_game11/audio/": "089f",
	"./informatyka/games/page006_game11/audio/index": "089f",
	"./informatyka/games/page006_game11/audio/index.js": "089f",
	"./informatyka/games/page006_game11/audio/polecenie.mp3": "1565",
	"./informatyka/games/page006_game11/audio/z3s7-b1.mp3": "2984",
	"./informatyka/games/page006_game11/audio/z3s7-b2.mp3": "85c1",
	"./informatyka/games/page006_game11/audio/z3s7-b3.mp3": "9926",
	"./informatyka/games/page006_game11/config": "d675",
	"./informatyka/games/page006_game11/config.js": "d675",
	"./informatyka/games/page006_game11/gameData.config": "9800",
	"./informatyka/games/page006_game11/gameData.config.js": "9800",
	"./informatyka/games/page006_game11/img": "ac49",
	"./informatyka/games/page006_game11/img/": "ac49",
	"./informatyka/games/page006_game11/img/bcg.jpg": "e971",
	"./informatyka/games/page006_game11/img/index": "ac49",
	"./informatyka/games/page006_game11/img/index.js": "ac49",
	"./informatyka/games/page006_game2/audio": "c095",
	"./informatyka/games/page006_game2/audio/": "c095",
	"./informatyka/games/page006_game2/audio/bad.mp3": "ec10",
	"./informatyka/games/page006_game2/audio/good.mp3": "4982",
	"./informatyka/games/page006_game2/audio/index": "c095",
	"./informatyka/games/page006_game2/audio/index.js": "c095",
	"./informatyka/games/page006_game2/audio/klik.mp3": "3936",
	"./informatyka/games/page006_game2/audio/z6c2-brawo.mp3": "872f",
	"./informatyka/games/page006_game2/audio/z6c2.mp3": "8a4e",
	"./informatyka/games/page006_game2/config": "08bf",
	"./informatyka/games/page006_game2/config.js": "08bf",
	"./informatyka/games/page006_game2/gameData.config": "efe6",
	"./informatyka/games/page006_game2/gameData.config.js": "efe6",
	"./informatyka/games/page006_game2/img": "82cf",
	"./informatyka/games/page006_game2/img/": "82cf",
	"./informatyka/games/page006_game2/img/00.png": "27a9",
	"./informatyka/games/page006_game2/img/01.png": "f998",
	"./informatyka/games/page006_game2/img/02.png": "0cd8",
	"./informatyka/games/page006_game2/img/03.png": "2332",
	"./informatyka/games/page006_game2/img/04.png": "66c8",
	"./informatyka/games/page006_game2/img/05.png": "118f5",
	"./informatyka/games/page006_game2/img/06.png": "9ca8",
	"./informatyka/games/page006_game2/img/07.png": "ebe7",
	"./informatyka/games/page006_game2/img/08.png": "1ae1",
	"./informatyka/games/page006_game2/img/09.png": "6424",
	"./informatyka/games/page006_game2/img/10.png": "289e",
	"./informatyka/games/page006_game2/img/11.png": "3bc3",
	"./informatyka/games/page006_game2/img/12.png": "39ab",
	"./informatyka/games/page006_game2/img/13.png": "2344",
	"./informatyka/games/page006_game2/img/14.png": "1e25",
	"./informatyka/games/page006_game2/img/15.png": "7a21",
	"./informatyka/games/page006_game2/img/20.png": "74b7",
	"./informatyka/games/page006_game2/img/21.png": "3984",
	"./informatyka/games/page006_game2/img/bcg.png": "3b45",
	"./informatyka/games/page006_game2/img/index": "82cf",
	"./informatyka/games/page006_game2/img/index.js": "82cf",
	"./informatyka/games/page006_game3/audio": "1ee4",
	"./informatyka/games/page006_game3/audio/": "1ee4",
	"./informatyka/games/page006_game3/audio/index": "1ee4",
	"./informatyka/games/page006_game3/audio/index.js": "1ee4",
	"./informatyka/games/page006_game3/audio/klik.mp3": "3fa5",
	"./informatyka/games/page006_game3/audio/z6c2-1.mp3": "0bfd",
	"./informatyka/games/page006_game3/audio/z6c2-2.mp3": "ce74",
	"./informatyka/games/page006_game3/audio/z6c2-3.mp3": "599a",
	"./informatyka/games/page006_game3/audio/z6c2-4.mp3": "4c56",
	"./informatyka/games/page006_game3/audio/z6c2-5.mp3": "7ddf",
	"./informatyka/games/page006_game3/audio/z6c3-brawo.mp3": "319d",
	"./informatyka/games/page006_game3/audio/z6c3-polecenie.mp3": "024a",
	"./informatyka/games/page006_game3/config": "7e6f",
	"./informatyka/games/page006_game3/config.js": "7e6f",
	"./informatyka/games/page006_game3/gameData.config": "a1c2",
	"./informatyka/games/page006_game3/gameData.config.js": "a1c2",
	"./informatyka/games/page006_game3/img": "764b",
	"./informatyka/games/page006_game3/img/": "764b",
	"./informatyka/games/page006_game3/img/00.png": "968f",
	"./informatyka/games/page006_game3/img/01.png": "9a2e",
	"./informatyka/games/page006_game3/img/02.png": "0907",
	"./informatyka/games/page006_game3/img/03.png": "04dc",
	"./informatyka/games/page006_game3/img/04.png": "ae91",
	"./informatyka/games/page006_game3/img/10.png": "da5e",
	"./informatyka/games/page006_game3/img/11.png": "4b7d",
	"./informatyka/games/page006_game3/img/12.png": "009b",
	"./informatyka/games/page006_game3/img/13.png": "58d9",
	"./informatyka/games/page006_game3/img/14.png": "715f",
	"./informatyka/games/page006_game3/img/bgr.png": "9b29",
	"./informatyka/games/page006_game3/img/index": "764b",
	"./informatyka/games/page006_game3/img/index.js": "764b",
	"./informatyka/games/page007_game1/audio": "bd1a",
	"./informatyka/games/page007_game1/audio/": "bd1a",
	"./informatyka/games/page007_game1/audio/index": "bd1a",
	"./informatyka/games/page007_game1/audio/index.js": "bd1a",
	"./informatyka/games/page007_game1/audio/z7c1-brawo.mp3": "bb63",
	"./informatyka/games/page007_game1/audio/z7c1.mp3": "b66f",
	"./informatyka/games/page007_game1/config": "9221",
	"./informatyka/games/page007_game1/config.js": "9221",
	"./informatyka/games/page007_game1/gameData.config": "c5f2",
	"./informatyka/games/page007_game1/gameData.config.js": "c5f2",
	"./informatyka/games/page007_game1/img": "61e8",
	"./informatyka/games/page007_game1/img/": "61e8",
	"./informatyka/games/page007_game1/img/1.jpg": "d9af",
	"./informatyka/games/page007_game1/img/index": "61e8",
	"./informatyka/games/page007_game1/img/index.js": "61e8",
	"./informatyka/games/page007_game2/audio": "9596",
	"./informatyka/games/page007_game2/audio/": "9596",
	"./informatyka/games/page007_game2/audio/index": "9596",
	"./informatyka/games/page007_game2/audio/index.js": "9596",
	"./informatyka/games/page007_game2/audio/polecenie.mp3": "5469",
	"./informatyka/games/page007_game2/audio/test.mp3": "e56b",
	"./informatyka/games/page007_game2/audio/z3s7-1.mp3": "8596",
	"./informatyka/games/page007_game2/audio/z3s7-2.mp3": "c879",
	"./informatyka/games/page007_game2/audio/z3s7-3.mp3": "12ef",
	"./informatyka/games/page007_game2/config": "d982",
	"./informatyka/games/page007_game2/config.js": "d982",
	"./informatyka/games/page007_game2/gameData.config": "42db",
	"./informatyka/games/page007_game2/gameData.config.js": "42db",
	"./informatyka/games/page007_game2/img": "c715",
	"./informatyka/games/page007_game2/img/": "c715",
	"./informatyka/games/page007_game2/img/bcg.jpg": "6270",
	"./informatyka/games/page007_game2/img/index": "c715",
	"./informatyka/games/page007_game2/img/index.js": "c715",
	"./informatyka/games/page007_game3/audio": "8f5e",
	"./informatyka/games/page007_game3/audio/": "8f5e",
	"./informatyka/games/page007_game3/audio/index": "8f5e",
	"./informatyka/games/page007_game3/audio/index.js": "8f5e",
	"./informatyka/games/page007_game3/audio/klik.mp3": "eeb3",
	"./informatyka/games/page007_game3/audio/test.mp3": "08c1",
	"./informatyka/games/page007_game3/audio/z3s7.mp3": "b21c",
	"./informatyka/games/page007_game3/audio/z7c3-brawo.mp3": "119b",
	"./informatyka/games/page007_game3/audio/z7c3.mp3": "dafc",
	"./informatyka/games/page007_game3/config": "d47f",
	"./informatyka/games/page007_game3/config.js": "d47f",
	"./informatyka/games/page007_game3/gameData.config": "f1e4",
	"./informatyka/games/page007_game3/gameData.config.js": "f1e4",
	"./informatyka/games/page007_game3/img": "e922",
	"./informatyka/games/page007_game3/img/": "e922",
	"./informatyka/games/page007_game3/img/bcg.png": "614f",
	"./informatyka/games/page007_game3/img/bottom.png": "cc40",
	"./informatyka/games/page007_game3/img/index": "e922",
	"./informatyka/games/page007_game3/img/index.js": "e922",
	"./informatyka/games/page007_game3/img/left.png": "525a",
	"./informatyka/games/page007_game3/img/plansza.png": "0f5a",
	"./informatyka/games/page007_game3/img/right.png": "ccc1",
	"./informatyka/games/page007_game3/img/top.png": "652b",
	"./informatyka/games/page007_game4/audio": "b70b",
	"./informatyka/games/page007_game4/audio/": "b70b",
	"./informatyka/games/page007_game4/audio/index": "b70b",
	"./informatyka/games/page007_game4/audio/index.js": "b70b",
	"./informatyka/games/page007_game4/audio/klik.mp3": "d78b",
	"./informatyka/games/page007_game4/audio/z7c4-brawo.mp3": "460f",
	"./informatyka/games/page007_game4/audio/z7c4.mp3": "82b1",
	"./informatyka/games/page007_game4/config": "b9d7",
	"./informatyka/games/page007_game4/config.js": "b9d7",
	"./informatyka/games/page007_game4/gameData.config": "aace",
	"./informatyka/games/page007_game4/gameData.config.js": "aace",
	"./informatyka/games/page007_game4/img": "f234",
	"./informatyka/games/page007_game4/img/": "f234",
	"./informatyka/games/page007_game4/img/arrow.png": "090b",
	"./informatyka/games/page007_game4/img/bgr.jpg": "0dbb",
	"./informatyka/games/page007_game4/img/index": "f234",
	"./informatyka/games/page007_game4/img/index.js": "f234",
	"./informatyka/games/page007_game4/img/maze.jpg": "e997",
	"./informatyka/games/page008_game1/audio": "3453",
	"./informatyka/games/page008_game1/audio/": "3453",
	"./informatyka/games/page008_game1/audio/index": "3453",
	"./informatyka/games/page008_game1/audio/index.js": "3453",
	"./informatyka/games/page008_game1/audio/klik.mp3": "f9de",
	"./informatyka/games/page008_game1/audio/z8c1-brawo.mp3": "2139",
	"./informatyka/games/page008_game1/audio/z8c1.mp3": "4bda",
	"./informatyka/games/page008_game1/config": "1b54",
	"./informatyka/games/page008_game1/config.js": "1b54",
	"./informatyka/games/page008_game1/gameData.config": "ec06",
	"./informatyka/games/page008_game1/gameData.config.js": "ec06",
	"./informatyka/games/page008_game1/img": "3098",
	"./informatyka/games/page008_game1/img/": "3098",
	"./informatyka/games/page008_game1/img/00.png": "5ff1",
	"./informatyka/games/page008_game1/img/01.png": "44c2",
	"./informatyka/games/page008_game1/img/02.png": "ee25",
	"./informatyka/games/page008_game1/img/03.png": "6635",
	"./informatyka/games/page008_game1/img/04.png": "5de4",
	"./informatyka/games/page008_game1/img/05.png": "fb92",
	"./informatyka/games/page008_game1/img/06.png": "44fe4",
	"./informatyka/games/page008_game1/img/07.png": "5e73",
	"./informatyka/games/page008_game1/img/08.png": "ee4a",
	"./informatyka/games/page008_game1/img/09.png": "a3da",
	"./informatyka/games/page008_game1/img/10.png": "b199",
	"./informatyka/games/page008_game1/img/11.png": "2b96",
	"./informatyka/games/page008_game1/img/12.png": "1931",
	"./informatyka/games/page008_game1/img/13.png": "6e69",
	"./informatyka/games/page008_game1/img/14.png": "5211",
	"./informatyka/games/page008_game1/img/15.png": "9679",
	"./informatyka/games/page008_game1/img/16.png": "27fa",
	"./informatyka/games/page008_game1/img/20.png": "46d11",
	"./informatyka/games/page008_game1/img/21.png": "f9a6",
	"./informatyka/games/page008_game1/img/22.png": "7b53",
	"./informatyka/games/page008_game1/img/23.png": "041e",
	"./informatyka/games/page008_game1/img/bgr.png": "5bbb",
	"./informatyka/games/page008_game1/img/index": "3098",
	"./informatyka/games/page008_game1/img/index.js": "3098",
	"./informatyka/games/page009_game1/audio": "8042",
	"./informatyka/games/page009_game1/audio/": "8042",
	"./informatyka/games/page009_game1/audio/index": "8042",
	"./informatyka/games/page009_game1/audio/index.js": "8042",
	"./informatyka/games/page009_game1/audio/polecenie.mp3": "fd50",
	"./informatyka/games/page009_game1/audio/z4s9-1.mp3": "56c0",
	"./informatyka/games/page009_game1/audio/z4s9-10.mp3": "c02b",
	"./informatyka/games/page009_game1/audio/z4s9-2.mp3": "c9a5",
	"./informatyka/games/page009_game1/audio/z4s9-3.mp3": "801b",
	"./informatyka/games/page009_game1/audio/z4s9-4.mp3": "cef3",
	"./informatyka/games/page009_game1/audio/z4s9-5.mp3": "ba57",
	"./informatyka/games/page009_game1/audio/z4s9-6.mp3": "4f63",
	"./informatyka/games/page009_game1/audio/z4s9-7.mp3": "299a",
	"./informatyka/games/page009_game1/audio/z4s9-8.mp3": "3d22",
	"./informatyka/games/page009_game1/audio/z4s9-9.mp3": "132d",
	"./informatyka/games/page009_game1/config": "854f",
	"./informatyka/games/page009_game1/config.js": "854f",
	"./informatyka/games/page009_game1/gameData.config": "7656",
	"./informatyka/games/page009_game1/gameData.config.js": "7656",
	"./informatyka/games/page009_game1/img": "0cdd",
	"./informatyka/games/page009_game1/img/": "0cdd",
	"./informatyka/games/page009_game1/img/bcg.jpg": "73f3",
	"./informatyka/games/page009_game1/img/index": "0cdd",
	"./informatyka/games/page009_game1/img/index.js": "0cdd",
	"./informatyka/games/page009_game2/audio": "9516",
	"./informatyka/games/page009_game2/audio/": "9516",
	"./informatyka/games/page009_game2/audio/index": "9516",
	"./informatyka/games/page009_game2/audio/index.js": "9516",
	"./informatyka/games/page009_game2/audio/polecenie.mp3": "c817",
	"./informatyka/games/page009_game2/audio/test.mp3": "e0b0",
	"./informatyka/games/page009_game2/audio/z3s7-1.mp3": "6c5e",
	"./informatyka/games/page009_game2/audio/z3s7-2.mp3": "4f4c",
	"./informatyka/games/page009_game2/audio/z3s7-3.mp3": "78fd",
	"./informatyka/games/page009_game2/config": "72c9",
	"./informatyka/games/page009_game2/config.js": "72c9",
	"./informatyka/games/page009_game2/gameData.config": "e0dd",
	"./informatyka/games/page009_game2/gameData.config.js": "e0dd",
	"./informatyka/games/page009_game2/img": "7992",
	"./informatyka/games/page009_game2/img/": "7992",
	"./informatyka/games/page009_game2/img/bcg.jpg": "4560",
	"./informatyka/games/page009_game2/img/index": "7992",
	"./informatyka/games/page009_game2/img/index.js": "7992",
	"./informatyka/games/page009_game3/audio": "8ebc",
	"./informatyka/games/page009_game3/audio/": "8ebc",
	"./informatyka/games/page009_game3/audio/index": "8ebc",
	"./informatyka/games/page009_game3/audio/index.js": "8ebc",
	"./informatyka/games/page009_game3/audio/polecenie.mp3": "fdbf",
	"./informatyka/games/page009_game3/audio/test.mp3": "87c2",
	"./informatyka/games/page009_game3/audio/z3s7-1.mp3": "44f6",
	"./informatyka/games/page009_game3/audio/z3s7-2.mp3": "b6aa",
	"./informatyka/games/page009_game3/audio/z3s7-3.mp3": "e512",
	"./informatyka/games/page009_game3/config": "54b5",
	"./informatyka/games/page009_game3/config.js": "54b5",
	"./informatyka/games/page009_game3/gameData.config": "2c6a",
	"./informatyka/games/page009_game3/gameData.config.js": "2c6a",
	"./informatyka/games/page009_game3/img": "bde2",
	"./informatyka/games/page009_game3/img/": "bde2",
	"./informatyka/games/page009_game3/img/bcg.jpg": "acbd",
	"./informatyka/games/page009_game3/img/index": "bde2",
	"./informatyka/games/page009_game3/img/index.js": "bde2",
	"./informatyka/games/page010_game1/audio": "3fcb",
	"./informatyka/games/page010_game1/audio/": "3fcb",
	"./informatyka/games/page010_game1/audio/index": "3fcb",
	"./informatyka/games/page010_game1/audio/index.js": "3fcb",
	"./informatyka/games/page010_game1/audio/klik.mp3": "9ec0",
	"./informatyka/games/page010_game1/audio/z10c1-brawo.mp3": "545d",
	"./informatyka/games/page010_game1/audio/z10c1.mp3": "7b8c",
	"./informatyka/games/page010_game1/config": "97eb",
	"./informatyka/games/page010_game1/config.js": "97eb",
	"./informatyka/games/page010_game1/gameData.config": "f8d2",
	"./informatyka/games/page010_game1/gameData.config.js": "f8d2",
	"./informatyka/games/page010_game1/img": "9f38",
	"./informatyka/games/page010_game1/img/": "9f38",
	"./informatyka/games/page010_game1/img/bcg.jpg": "624a",
	"./informatyka/games/page010_game1/img/check.png": "f444",
	"./informatyka/games/page010_game1/img/index": "9f38",
	"./informatyka/games/page010_game1/img/index.js": "9f38",
	"./informatyka/games/page010_game4/audio": "cf7c",
	"./informatyka/games/page010_game4/audio/": "cf7c",
	"./informatyka/games/page010_game4/audio/index": "cf7c",
	"./informatyka/games/page010_game4/audio/index.js": "cf7c",
	"./informatyka/games/page010_game4/audio/klik.mp3": "e586",
	"./informatyka/games/page010_game4/audio/z10c4-brawo.mp3": "3502",
	"./informatyka/games/page010_game4/audio/z10c4.mp3": "0762",
	"./informatyka/games/page010_game4/config": "2d3c",
	"./informatyka/games/page010_game4/config.js": "2d3c",
	"./informatyka/games/page010_game4/gameData.config": "2a31",
	"./informatyka/games/page010_game4/gameData.config.js": "2a31",
	"./informatyka/games/page010_game4/img": "fd1e",
	"./informatyka/games/page010_game4/img/": "fd1e",
	"./informatyka/games/page010_game4/img/00.jpg": "10e1",
	"./informatyka/games/page010_game4/img/00.png": "a50a",
	"./informatyka/games/page010_game4/img/01.jpg": "c796",
	"./informatyka/games/page010_game4/img/01.png": "b4d7",
	"./informatyka/games/page010_game4/img/02.png": "1c03",
	"./informatyka/games/page010_game4/img/03.png": "20ff",
	"./informatyka/games/page010_game4/img/04.png": "101c",
	"./informatyka/games/page010_game4/img/05.png": "afd5",
	"./informatyka/games/page010_game4/img/10.png": "8264",
	"./informatyka/games/page010_game4/img/11.png": "cce9",
	"./informatyka/games/page010_game4/img/12.png": "8e14",
	"./informatyka/games/page010_game4/img/13.png": "8b54",
	"./informatyka/games/page010_game4/img/14.png": "2ee1",
	"./informatyka/games/page010_game4/img/15.png": "fe67",
	"./informatyka/games/page010_game4/img/20.png": "a375",
	"./informatyka/games/page010_game4/img/21.png": "de10",
	"./informatyka/games/page010_game4/img/30.png": "dd11",
	"./informatyka/games/page010_game4/img/31.png": "a10f",
	"./informatyka/games/page010_game4/img/bcg.png": "a680",
	"./informatyka/games/page010_game4/img/index": "fd1e",
	"./informatyka/games/page010_game4/img/index.js": "fd1e",
	"./informatyka/games/page011_game3/audio": "099c",
	"./informatyka/games/page011_game3/audio/": "099c",
	"./informatyka/games/page011_game3/audio/index": "099c",
	"./informatyka/games/page011_game3/audio/index.js": "099c",
	"./informatyka/games/page011_game3/audio/klik.mp3": "e39a",
	"./informatyka/games/page011_game3/audio/z11c3-brawo.mp3": "a07e",
	"./informatyka/games/page011_game3/audio/z11c3.mp3": "a925",
	"./informatyka/games/page011_game3/config": "5fd2",
	"./informatyka/games/page011_game3/config.js": "5fd2",
	"./informatyka/games/page011_game3/gameData.config": "3e18",
	"./informatyka/games/page011_game3/gameData.config.js": "3e18",
	"./informatyka/games/page011_game3/img": "1179",
	"./informatyka/games/page011_game3/img/": "1179",
	"./informatyka/games/page011_game3/img/00.png": "be82",
	"./informatyka/games/page011_game3/img/01.png": "efab",
	"./informatyka/games/page011_game3/img/02.png": "4705",
	"./informatyka/games/page011_game3/img/bgr.png": "1dd6",
	"./informatyka/games/page011_game3/img/index": "1179",
	"./informatyka/games/page011_game3/img/index.js": "1179",
	"./informatyka/games/page011_game4/audio": "b1a6",
	"./informatyka/games/page011_game4/audio/": "b1a6",
	"./informatyka/games/page011_game4/audio/index": "b1a6",
	"./informatyka/games/page011_game4/audio/index.js": "b1a6",
	"./informatyka/games/page011_game4/audio/polecenie.mp3": "43c0",
	"./informatyka/games/page011_game4/audio/z5s11-a1.mp3": "2d42",
	"./informatyka/games/page011_game4/audio/z5s11-a2.mp3": "27fe",
	"./informatyka/games/page011_game4/config": "33f5",
	"./informatyka/games/page011_game4/config.js": "33f5",
	"./informatyka/games/page011_game4/gameData.config": "ec34",
	"./informatyka/games/page011_game4/gameData.config.js": "ec34",
	"./informatyka/games/page011_game4/img": "df56",
	"./informatyka/games/page011_game4/img/": "df56",
	"./informatyka/games/page011_game4/img/bcg.jpg": "c493",
	"./informatyka/games/page011_game4/img/index": "df56",
	"./informatyka/games/page011_game4/img/index.js": "df56",
	"./informatyka/games/page011_game5/audio": "4a62",
	"./informatyka/games/page011_game5/audio/": "4a62",
	"./informatyka/games/page011_game5/audio/index": "4a62",
	"./informatyka/games/page011_game5/audio/index.js": "4a62",
	"./informatyka/games/page011_game5/audio/polecenie.mp3": "b783",
	"./informatyka/games/page011_game5/audio/z5s11-b1.mp3": "39a5",
	"./informatyka/games/page011_game5/audio/z5s11-b2.mp3": "84ce",
	"./informatyka/games/page011_game5/config": "d34b",
	"./informatyka/games/page011_game5/config.js": "d34b",
	"./informatyka/games/page011_game5/gameData.config": "769e",
	"./informatyka/games/page011_game5/gameData.config.js": "769e",
	"./informatyka/games/page011_game5/img": "c3c7",
	"./informatyka/games/page011_game5/img/": "c3c7",
	"./informatyka/games/page011_game5/img/bcg.jpg": "72e3",
	"./informatyka/games/page011_game5/img/index": "c3c7",
	"./informatyka/games/page011_game5/img/index.js": "c3c7",
	"./informatyka/games/page012_game1/audio": "a31d",
	"./informatyka/games/page012_game1/audio/": "a31d",
	"./informatyka/games/page012_game1/audio/index": "a31d",
	"./informatyka/games/page012_game1/audio/index.js": "a31d",
	"./informatyka/games/page012_game1/audio/klik.mp3": "4773",
	"./informatyka/games/page012_game1/audio/z12c1-brawo.mp3": "576c",
	"./informatyka/games/page012_game1/audio/z12c1.mp3": "fa29",
	"./informatyka/games/page012_game1/config": "355e",
	"./informatyka/games/page012_game1/config.js": "355e",
	"./informatyka/games/page012_game1/gameData.config": "3362",
	"./informatyka/games/page012_game1/gameData.config.js": "3362",
	"./informatyka/games/page012_game1/img": "3363",
	"./informatyka/games/page012_game1/img/": "3363",
	"./informatyka/games/page012_game1/img/00.png": "432e",
	"./informatyka/games/page012_game1/img/01.png": "ce44",
	"./informatyka/games/page012_game1/img/02.png": "2817",
	"./informatyka/games/page012_game1/img/03.png": "5d84",
	"./informatyka/games/page012_game1/img/04.png": "bf86",
	"./informatyka/games/page012_game1/img/05.png": "722c",
	"./informatyka/games/page012_game1/img/bgr.png": "7f84",
	"./informatyka/games/page012_game1/img/index": "3363",
	"./informatyka/games/page012_game1/img/index.js": "3363",
	"./informatyka/games/page012_game4/audio": "bda7",
	"./informatyka/games/page012_game4/audio/": "bda7",
	"./informatyka/games/page012_game4/audio/index": "bda7",
	"./informatyka/games/page012_game4/audio/index.js": "bda7",
	"./informatyka/games/page012_game4/audio/z12c4-brawo.mp3": "53c1",
	"./informatyka/games/page012_game4/audio/z12c4.mp3": "ce53",
	"./informatyka/games/page012_game4/config": "3ea1",
	"./informatyka/games/page012_game4/config.js": "3ea1",
	"./informatyka/games/page012_game4/gameData.config": "c886",
	"./informatyka/games/page012_game4/gameData.config.js": "c886",
	"./informatyka/games/page012_game4/img": "904b",
	"./informatyka/games/page012_game4/img/": "904b",
	"./informatyka/games/page012_game4/img/00.png": "2e5c",
	"./informatyka/games/page012_game4/img/01.png": "e9e9",
	"./informatyka/games/page012_game4/img/02.png": "e28d",
	"./informatyka/games/page012_game4/img/03.png": "5f77",
	"./informatyka/games/page012_game4/img/index": "904b",
	"./informatyka/games/page012_game4/img/index.js": "904b",
	"./informatyka/games/page013_game4/audio": "29c2",
	"./informatyka/games/page013_game4/audio/": "29c2",
	"./informatyka/games/page013_game4/audio/index": "29c2",
	"./informatyka/games/page013_game4/audio/index.js": "29c2",
	"./informatyka/games/page013_game4/audio/klik.mp3": "87c2f",
	"./informatyka/games/page013_game4/audio/z13c4-brawo.mp3": "479c",
	"./informatyka/games/page013_game4/audio/z13c4.mp3": "da3c",
	"./informatyka/games/page013_game4/config": "ede1",
	"./informatyka/games/page013_game4/config.js": "ede1",
	"./informatyka/games/page013_game4/gameData.config": "4e1a",
	"./informatyka/games/page013_game4/gameData.config.js": "4e1a",
	"./informatyka/games/page013_game4/img": "cf76",
	"./informatyka/games/page013_game4/img/": "cf76",
	"./informatyka/games/page013_game4/img/00.jpg": "f3a2",
	"./informatyka/games/page013_game4/img/01.jpg": "1afb",
	"./informatyka/games/page013_game4/img/02.jpg": "8b23",
	"./informatyka/games/page013_game4/img/03.jpg": "9d55",
	"./informatyka/games/page013_game4/img/04.jpg": "7a64",
	"./informatyka/games/page013_game4/img/05.jpg": "70a1",
	"./informatyka/games/page013_game4/img/06.jpg": "e974",
	"./informatyka/games/page013_game4/img/07.jpg": "b6ec",
	"./informatyka/games/page013_game4/img/08.jpg": "55ca",
	"./informatyka/games/page013_game4/img/09.jpg": "3cea",
	"./informatyka/games/page013_game4/img/09.png": "9c9f",
	"./informatyka/games/page013_game4/img/10.png": "da7f",
	"./informatyka/games/page013_game4/img/11.png": "30ec",
	"./informatyka/games/page013_game4/img/20.png": "8880",
	"./informatyka/games/page013_game4/img/bcg.png": "8dc0",
	"./informatyka/games/page013_game4/img/index": "cf76",
	"./informatyka/games/page013_game4/img/index.js": "cf76",
	"./informatyka/games/page013_game5/audio": "c5dd",
	"./informatyka/games/page013_game5/audio/": "c5dd",
	"./informatyka/games/page013_game5/audio/index": "c5dd",
	"./informatyka/games/page013_game5/audio/index.js": "c5dd",
	"./informatyka/games/page013_game5/audio/polecenie.mp3": "bf78",
	"./informatyka/games/page013_game5/audio/z6s13-1.mp3": "2749",
	"./informatyka/games/page013_game5/audio/z6s13-2.mp3": "a6e3",
	"./informatyka/games/page013_game5/audio/z6s13-3.mp3": "33ba",
	"./informatyka/games/page013_game5/audio/z6s13-4.mp3": "37a7",
	"./informatyka/games/page013_game5/audio/z6s13-5.mp3": "2c0e",
	"./informatyka/games/page013_game5/config": "26ae",
	"./informatyka/games/page013_game5/config.js": "26ae",
	"./informatyka/games/page013_game5/gameData.config": "9657",
	"./informatyka/games/page013_game5/gameData.config.js": "9657",
	"./informatyka/games/page013_game5/img": "eb90",
	"./informatyka/games/page013_game5/img/": "eb90",
	"./informatyka/games/page013_game5/img/bcg.jpg": "9283",
	"./informatyka/games/page013_game5/img/index": "eb90",
	"./informatyka/games/page013_game5/img/index.js": "eb90",
	"./informatyka/games/page014_game4/audio": "752a",
	"./informatyka/games/page014_game4/audio/": "752a",
	"./informatyka/games/page014_game4/audio/index": "752a",
	"./informatyka/games/page014_game4/audio/index.js": "752a",
	"./informatyka/games/page014_game4/audio/klik.mp3": "a066",
	"./informatyka/games/page014_game4/audio/z14c4-brawo.mp3": "c9a6",
	"./informatyka/games/page014_game4/audio/z14c4.mp3": "0bf1",
	"./informatyka/games/page014_game4/config": "64ee",
	"./informatyka/games/page014_game4/config.js": "64ee",
	"./informatyka/games/page014_game4/gameData.config": "06d9",
	"./informatyka/games/page014_game4/gameData.config.js": "06d9",
	"./informatyka/games/page014_game4/img": "85bf",
	"./informatyka/games/page014_game4/img/": "85bf",
	"./informatyka/games/page014_game4/img/00.png": "2098",
	"./informatyka/games/page014_game4/img/01.png": "103c",
	"./informatyka/games/page014_game4/img/02.png": "bb36",
	"./informatyka/games/page014_game4/img/03.png": "7d0a",
	"./informatyka/games/page014_game4/img/04.png": "8014",
	"./informatyka/games/page014_game4/img/10.png": "e523",
	"./informatyka/games/page014_game4/img/11.png": "7698",
	"./informatyka/games/page014_game4/img/12.png": "916c",
	"./informatyka/games/page014_game4/img/13.png": "d9bb",
	"./informatyka/games/page014_game4/img/14.png": "5b5c",
	"./informatyka/games/page014_game4/img/bcg.png": "4f7a",
	"./informatyka/games/page014_game4/img/index": "85bf",
	"./informatyka/games/page014_game4/img/index.js": "85bf",
	"./informatyka/games/page014_game4/img/point.png": "1f70",
	"./informatyka/games/page016_game1/audio": "1272",
	"./informatyka/games/page016_game1/audio/": "1272",
	"./informatyka/games/page016_game1/audio/index": "1272",
	"./informatyka/games/page016_game1/audio/index.js": "1272",
	"./informatyka/games/page016_game1/audio/klik.mp3": "46c3",
	"./informatyka/games/page016_game1/audio/z16c1-brawo.mp3": "b636",
	"./informatyka/games/page016_game1/audio/z16c1.mp3": "3d75",
	"./informatyka/games/page016_game1/config": "3432",
	"./informatyka/games/page016_game1/config.js": "3432",
	"./informatyka/games/page016_game1/gameData.config": "27b2",
	"./informatyka/games/page016_game1/gameData.config.js": "27b2",
	"./informatyka/games/page016_game1/img": "3478",
	"./informatyka/games/page016_game1/img/": "3478",
	"./informatyka/games/page016_game1/img/00.png": "ab6d",
	"./informatyka/games/page016_game1/img/01.png": "3b36",
	"./informatyka/games/page016_game1/img/02.png": "1165",
	"./informatyka/games/page016_game1/img/12.png": "aa54",
	"./informatyka/games/page016_game1/img/20.png": "ac3b",
	"./informatyka/games/page016_game1/img/21.png": "c744",
	"./informatyka/games/page016_game1/img/22.png": "9642",
	"./informatyka/games/page016_game1/img/30.png": "9e47",
	"./informatyka/games/page016_game1/img/31.png": "f4cf",
	"./informatyka/games/page016_game1/img/32.png": "7db6",
	"./informatyka/games/page016_game1/img/34.png": "d296",
	"./informatyka/games/page016_game1/img/40.png": "64db",
	"./informatyka/games/page016_game1/img/41.png": "6bc9",
	"./informatyka/games/page016_game1/img/42.png": "d6b0",
	"./informatyka/games/page016_game1/img/43.png": "073e",
	"./informatyka/games/page016_game1/img/bcg.png": "02b6",
	"./informatyka/games/page016_game1/img/index": "3478",
	"./informatyka/games/page016_game1/img/index.js": "3478",
	"./informatyka/games/page016_game10/audio": "20ec",
	"./informatyka/games/page016_game10/audio/": "20ec",
	"./informatyka/games/page016_game10/audio/index": "20ec",
	"./informatyka/games/page016_game10/audio/index.js": "20ec",
	"./informatyka/games/page016_game10/audio/polecenie.mp3": "7522",
	"./informatyka/games/page016_game10/audio/z8s16-1.mp3": "97e4",
	"./informatyka/games/page016_game10/audio/z8s16-2.mp3": "3f8f",
	"./informatyka/games/page016_game10/audio/z8s16-3.mp3": "8788",
	"./informatyka/games/page016_game10/audio/z8s16-4.mp3": "8c1c",
	"./informatyka/games/page016_game10/config": "4183",
	"./informatyka/games/page016_game10/config.js": "4183",
	"./informatyka/games/page016_game10/gameData.config": "44a8",
	"./informatyka/games/page016_game10/gameData.config.js": "44a8",
	"./informatyka/games/page016_game10/img": "6255",
	"./informatyka/games/page016_game10/img/": "6255",
	"./informatyka/games/page016_game10/img/bcg.jpg": "2900",
	"./informatyka/games/page016_game10/img/index": "6255",
	"./informatyka/games/page016_game10/img/index.js": "6255",
	"./informatyka/games/page016_game4/audio": "4f7d",
	"./informatyka/games/page016_game4/audio/": "4f7d",
	"./informatyka/games/page016_game4/audio/index": "4f7d",
	"./informatyka/games/page016_game4/audio/index.js": "4f7d",
	"./informatyka/games/page016_game4/audio/klik.mp3": "ba45",
	"./informatyka/games/page016_game4/audio/z16c4-brawo.mp3": "ce7f",
	"./informatyka/games/page016_game4/audio/z16c4.mp3": "245e",
	"./informatyka/games/page016_game4/config": "a20c",
	"./informatyka/games/page016_game4/config.js": "a20c",
	"./informatyka/games/page016_game4/gameData.config": "b7a9",
	"./informatyka/games/page016_game4/gameData.config.js": "b7a9",
	"./informatyka/games/page016_game4/img": "ba9f",
	"./informatyka/games/page016_game4/img/": "ba9f",
	"./informatyka/games/page016_game4/img/00.png": "b6a3",
	"./informatyka/games/page016_game4/img/01.png": "1fcb",
	"./informatyka/games/page016_game4/img/02.png": "5dc4",
	"./informatyka/games/page016_game4/img/03.png": "380f",
	"./informatyka/games/page016_game4/img/04.png": "9b90",
	"./informatyka/games/page016_game4/img/10.png": "cc4e",
	"./informatyka/games/page016_game4/img/11.png": "e0f3",
	"./informatyka/games/page016_game4/img/12.png": "3401",
	"./informatyka/games/page016_game4/img/13.png": "4526",
	"./informatyka/games/page016_game4/img/14.png": "2c19",
	"./informatyka/games/page016_game4/img/bcg.png": "00ca",
	"./informatyka/games/page016_game4/img/index": "ba9f",
	"./informatyka/games/page016_game4/img/index.js": "ba9f",
	"./informatyka/games/page016_game4/img/point.png": "4119",
	"./informatyka/games/page016_game7/audio": "13c8",
	"./informatyka/games/page016_game7/audio/": "13c8",
	"./informatyka/games/page016_game7/audio/index": "13c8",
	"./informatyka/games/page016_game7/audio/index.js": "13c8",
	"./informatyka/games/page016_game7/audio/z16c2-3-4.mp3": "861e",
	"./informatyka/games/page016_game7/audio/z3c2.mp3": "7b91",
	"./informatyka/games/page016_game7/config": "700d",
	"./informatyka/games/page016_game7/config.js": "700d",
	"./informatyka/games/page016_game7/gameData.config": "233c",
	"./informatyka/games/page016_game7/gameData.config.js": "233c",
	"./informatyka/games/page016_game7/img": "4d0d",
	"./informatyka/games/page016_game7/img/": "4d0d",
	"./informatyka/games/page016_game7/img/55862_0_basnie-rysunki konturowe il1_original2.png": "ef9a",
	"./informatyka/games/page016_game7/img/55862_0_basnie-rysunki konturowe il1_original2_out.png": "727c",
	"./informatyka/games/page016_game7/img/index": "4d0d",
	"./informatyka/games/page016_game7/img/index.js": "4d0d",
	"./informatyka/games/page016_game7/img/paleta_raster.png": "f8f6",
	"./informatyka/games/page016_game8/audio": "df95",
	"./informatyka/games/page016_game8/audio/": "df95",
	"./informatyka/games/page016_game8/audio/index": "df95",
	"./informatyka/games/page016_game8/audio/index.js": "df95",
	"./informatyka/games/page016_game8/audio/z16c2-3-4.mp3": "373e",
	"./informatyka/games/page016_game8/audio/z3c2.mp3": "9f9d",
	"./informatyka/games/page016_game8/config": "4826",
	"./informatyka/games/page016_game8/config.js": "4826",
	"./informatyka/games/page016_game8/gameData.config": "1e2e",
	"./informatyka/games/page016_game8/gameData.config.js": "1e2e",
	"./informatyka/games/page016_game8/img": "25c0",
	"./informatyka/games/page016_game8/img/": "25c0",
	"./informatyka/games/page016_game8/img/55862_0_basnie-rysunki konturowe il2_original2.png": "6673",
	"./informatyka/games/page016_game8/img/55862_0_basnie-rysunki konturowe il2_original2_out.png": "b220",
	"./informatyka/games/page016_game8/img/index": "25c0",
	"./informatyka/games/page016_game8/img/index.js": "25c0",
	"./informatyka/games/page016_game8/img/paleta_raster.png": "9149",
	"./informatyka/games/page016_game9/audio": "3bdb",
	"./informatyka/games/page016_game9/audio/": "3bdb",
	"./informatyka/games/page016_game9/audio/index": "3bdb",
	"./informatyka/games/page016_game9/audio/index.js": "3bdb",
	"./informatyka/games/page016_game9/audio/z16c2-3-4.mp3": "8075",
	"./informatyka/games/page016_game9/audio/z3c2.mp3": "641f",
	"./informatyka/games/page016_game9/config": "4435",
	"./informatyka/games/page016_game9/config.js": "4435",
	"./informatyka/games/page016_game9/gameData.config": "02c8",
	"./informatyka/games/page016_game9/gameData.config.js": "02c8",
	"./informatyka/games/page016_game9/img": "70e8",
	"./informatyka/games/page016_game9/img/": "70e8",
	"./informatyka/games/page016_game9/img/55862_0_basnie-rysunki konturowe il3_original2.png": "02d1",
	"./informatyka/games/page016_game9/img/55862_0_basnie-rysunki konturowe il3_original2_out.png": "dd02",
	"./informatyka/games/page016_game9/img/index": "70e8",
	"./informatyka/games/page016_game9/img/index.js": "70e8",
	"./informatyka/games/page016_game9/img/paleta_raster.png": "b71a",
	"./informatyka/games/page017_game1/audio": "d985",
	"./informatyka/games/page017_game1/audio/": "d985",
	"./informatyka/games/page017_game1/audio/index": "d985",
	"./informatyka/games/page017_game1/audio/index.js": "d985",
	"./informatyka/games/page017_game1/audio/klik.mp3": "9119",
	"./informatyka/games/page017_game1/audio/z17c1-brawo.mp3": "990b",
	"./informatyka/games/page017_game1/audio/z17c1.mp3": "6adb",
	"./informatyka/games/page017_game1/config": "b48a",
	"./informatyka/games/page017_game1/config.js": "b48a",
	"./informatyka/games/page017_game1/gameData.config": "ca86",
	"./informatyka/games/page017_game1/gameData.config.js": "ca86",
	"./informatyka/games/page017_game1/img": "fc1a",
	"./informatyka/games/page017_game1/img/": "fc1a",
	"./informatyka/games/page017_game1/img/00.png": "26a0",
	"./informatyka/games/page017_game1/img/01.png": "3ec3",
	"./informatyka/games/page017_game1/img/02.png": "4f9a",
	"./informatyka/games/page017_game1/img/03.png": "67f6",
	"./informatyka/games/page017_game1/img/04.png": "3080",
	"./informatyka/games/page017_game1/img/05.png": "97fb",
	"./informatyka/games/page017_game1/img/06.png": "70ef",
	"./informatyka/games/page017_game1/img/07.png": "af73",
	"./informatyka/games/page017_game1/img/08.png": "697c",
	"./informatyka/games/page017_game1/img/10.png": "53fe",
	"./informatyka/games/page017_game1/img/11.png": "bb3c",
	"./informatyka/games/page017_game1/img/12.png": "0e15",
	"./informatyka/games/page017_game1/img/13.png": "d08a",
	"./informatyka/games/page017_game1/img/20.png": "5ca3",
	"./informatyka/games/page017_game1/img/background.jpg": "bec6",
	"./informatyka/games/page017_game1/img/index": "fc1a",
	"./informatyka/games/page017_game1/img/index.js": "fc1a",
	"./informatyka/games/page017_game10/audio": "c0e3",
	"./informatyka/games/page017_game10/audio/": "c0e3",
	"./informatyka/games/page017_game10/audio/index": "c0e3",
	"./informatyka/games/page017_game10/audio/index.js": "c0e3",
	"./informatyka/games/page017_game10/audio/polecenie.mp3": "4f8a",
	"./informatyka/games/page017_game10/audio/z8s17-1.mp3": "123d",
	"./informatyka/games/page017_game10/audio/z8s17-2.mp3": "5754",
	"./informatyka/games/page017_game10/audio/z8s17-3.mp3": "c3f2",
	"./informatyka/games/page017_game10/audio/z8s17-4.mp3": "9528",
	"./informatyka/games/page017_game10/config": "f858",
	"./informatyka/games/page017_game10/config.js": "f858",
	"./informatyka/games/page017_game10/gameData.config": "05e3",
	"./informatyka/games/page017_game10/gameData.config.js": "05e3",
	"./informatyka/games/page017_game10/img": "cc9d",
	"./informatyka/games/page017_game10/img/": "cc9d",
	"./informatyka/games/page017_game10/img/bcg.jpg": "b93d",
	"./informatyka/games/page017_game10/img/bcg2.jpg": "6a2d",
	"./informatyka/games/page017_game10/img/index": "cc9d",
	"./informatyka/games/page017_game10/img/index.js": "cc9d",
	"./informatyka/games/page017_game11/audio": "afac",
	"./informatyka/games/page017_game11/audio/": "afac",
	"./informatyka/games/page017_game11/audio/index": "afac",
	"./informatyka/games/page017_game11/audio/index.js": "afac",
	"./informatyka/games/page017_game11/config": "8f31",
	"./informatyka/games/page017_game11/config.js": "8f31",
	"./informatyka/games/page017_game11/gameData.config": "9fe3",
	"./informatyka/games/page017_game11/gameData.config.js": "9fe3",
	"./informatyka/games/page017_game11/img": "c433",
	"./informatyka/games/page017_game11/img/": "c433",
	"./informatyka/games/page017_game11/img/index": "c433",
	"./informatyka/games/page017_game11/img/index.js": "c433",
	"./informatyka/games/page017_game12/audio": "c7f7",
	"./informatyka/games/page017_game12/audio/": "c7f7",
	"./informatyka/games/page017_game12/audio/index": "c7f7",
	"./informatyka/games/page017_game12/audio/index.js": "c7f7",
	"./informatyka/games/page017_game12/audio/polecenie.mp3": "07d1",
	"./informatyka/games/page017_game12/audio/z8s17-b1.mp3": "a3ba",
	"./informatyka/games/page017_game12/audio/z8s17-b2.mp3": "68c0",
	"./informatyka/games/page017_game12/config": "66ce",
	"./informatyka/games/page017_game12/config.js": "66ce",
	"./informatyka/games/page017_game12/gameData.config": "7d28",
	"./informatyka/games/page017_game12/gameData.config.js": "7d28",
	"./informatyka/games/page017_game12/img": "8f1a",
	"./informatyka/games/page017_game12/img/": "8f1a",
	"./informatyka/games/page017_game12/img/bcg.jpg": "c824",
	"./informatyka/games/page017_game12/img/index": "8f1a",
	"./informatyka/games/page017_game12/img/index.js": "8f1a",
	"./informatyka/games/page017_game2/audio": "59a9",
	"./informatyka/games/page017_game2/audio/": "59a9",
	"./informatyka/games/page017_game2/audio/index": "59a9",
	"./informatyka/games/page017_game2/audio/index.js": "59a9",
	"./informatyka/games/page017_game2/audio/klik.mp3": "b202",
	"./informatyka/games/page017_game2/audio/z17c2-brawo.mp3": "3031",
	"./informatyka/games/page017_game2/audio/z17c2.mp3": "c2d2",
	"./informatyka/games/page017_game2/config": "71f4",
	"./informatyka/games/page017_game2/config.js": "71f4",
	"./informatyka/games/page017_game2/gameData.config": "4c97",
	"./informatyka/games/page017_game2/gameData.config.js": "4c97",
	"./informatyka/games/page017_game2/img": "3597",
	"./informatyka/games/page017_game2/img/": "3597",
	"./informatyka/games/page017_game2/img/00.png": "976e",
	"./informatyka/games/page017_game2/img/01.png": "5ece",
	"./informatyka/games/page017_game2/img/02.png": "8d9d",
	"./informatyka/games/page017_game2/img/03.png": "06dd",
	"./informatyka/games/page017_game2/img/10.png": "608c",
	"./informatyka/games/page017_game2/img/11.png": "065b",
	"./informatyka/games/page017_game2/img/12.png": "40ab",
	"./informatyka/games/page017_game2/img/13.png": "38bf0",
	"./informatyka/games/page017_game2/img/background.jpg": "ef8d",
	"./informatyka/games/page017_game2/img/index": "3597",
	"./informatyka/games/page017_game2/img/index.js": "3597",
	"./informatyka/games/page017_game2/img/point.png": "109c",
	"./informatyka/games/page018_game0/audio": "f7fd",
	"./informatyka/games/page018_game0/audio/": "f7fd",
	"./informatyka/games/page018_game0/audio/index": "f7fd",
	"./informatyka/games/page018_game0/audio/index.js": "f7fd",
	"./informatyka/games/page018_game0/audio/klik.mp3": "eadf",
	"./informatyka/games/page018_game0/audio/z18c1-brawo.mp3": "0966",
	"./informatyka/games/page018_game0/audio/z18c1.mp3": "0155",
	"./informatyka/games/page018_game0/config": "d6f2",
	"./informatyka/games/page018_game0/config.js": "d6f2",
	"./informatyka/games/page018_game0/gameData.config": "21a9",
	"./informatyka/games/page018_game0/gameData.config.js": "21a9",
	"./informatyka/games/page018_game0/img": "9d51",
	"./informatyka/games/page018_game0/img/": "9d51",
	"./informatyka/games/page018_game0/img/00.png": "69ee",
	"./informatyka/games/page018_game0/img/01.png": "fc8e",
	"./informatyka/games/page018_game0/img/02.png": "7e57",
	"./informatyka/games/page018_game0/img/03.png": "aa26",
	"./informatyka/games/page018_game0/img/04.png": "cbd8",
	"./informatyka/games/page018_game0/img/bcg.png": "f002",
	"./informatyka/games/page018_game0/img/index": "9d51",
	"./informatyka/games/page018_game0/img/index.js": "9d51",
	"./informatyka/games/page018_game0/img/statusCorrect.png": "270b",
	"./informatyka/games/page018_game1/audio": "ecd5",
	"./informatyka/games/page018_game1/audio/": "ecd5",
	"./informatyka/games/page018_game1/audio/index": "ecd5",
	"./informatyka/games/page018_game1/audio/index.js": "ecd5",
	"./informatyka/games/page018_game1/audio/klik.mp3": "772e",
	"./informatyka/games/page018_game1/audio/z18c1-brawo.mp3": "ec89",
	"./informatyka/games/page018_game1/audio/z18c1.mp3": "c44e",
	"./informatyka/games/page018_game1/config": "9a3f",
	"./informatyka/games/page018_game1/config.js": "9a3f",
	"./informatyka/games/page018_game1/gameData.config": "4118",
	"./informatyka/games/page018_game1/gameData.config.js": "4118",
	"./informatyka/games/page018_game1/img": "2d03",
	"./informatyka/games/page018_game1/img/": "2d03",
	"./informatyka/games/page018_game1/img/00.png": "4a98",
	"./informatyka/games/page018_game1/img/01.png": "7309",
	"./informatyka/games/page018_game1/img/02.png": "59dd",
	"./informatyka/games/page018_game1/img/03.png": "ded2",
	"./informatyka/games/page018_game1/img/04.png": "155f",
	"./informatyka/games/page018_game1/img/bcg.jpg": "9722",
	"./informatyka/games/page018_game1/img/check.png": "934b",
	"./informatyka/games/page018_game1/img/index": "2d03",
	"./informatyka/games/page018_game1/img/index.js": "2d03",
	"./informatyka/games/page019_game1/audio": "004d",
	"./informatyka/games/page019_game1/audio/": "004d",
	"./informatyka/games/page019_game1/audio/f.mp3": "33b4",
	"./informatyka/games/page019_game1/audio/index": "004d",
	"./informatyka/games/page019_game1/audio/index.js": "004d",
	"./informatyka/games/page019_game1/audio/t.mp3": "6e7d",
	"./informatyka/games/page019_game1/audio/z19c1-brawo.mp3": "2c91",
	"./informatyka/games/page019_game1/audio/z19c1.mp3": "77a7",
	"./informatyka/games/page019_game1/config": "c3ea",
	"./informatyka/games/page019_game1/config.js": "c3ea",
	"./informatyka/games/page019_game1/gameData.config": "3c7c",
	"./informatyka/games/page019_game1/gameData.config.js": "3c7c",
	"./informatyka/games/page019_game1/img": "670f",
	"./informatyka/games/page019_game1/img/": "670f",
	"./informatyka/games/page019_game1/img/bcg.png": "c481",
	"./informatyka/games/page019_game1/img/f.png": "2289",
	"./informatyka/games/page019_game1/img/foka.jpg": "4511",
	"./informatyka/games/page019_game1/img/gitara.jpg": "662c",
	"./informatyka/games/page019_game1/img/hulajnoga.jpg": "8504",
	"./informatyka/games/page019_game1/img/igla.jpg": "2bbe",
	"./informatyka/games/page019_game1/img/index": "670f",
	"./informatyka/games/page019_game1/img/index.js": "670f",
	"./informatyka/games/page019_game1/img/jajko.jpg": "1caa",
	"./informatyka/games/page019_game1/img/kot.jpg": "1f2e",
	"./informatyka/games/page019_game1/img/lampa.jpg": "7240",
	"./informatyka/games/page019_game1/img/mrowka.jpg": "0a1e",
	"./informatyka/games/page019_game1/img/nozyczki.jpg": "b767",
	"./informatyka/games/page019_game1/img/okulary.jpg": "19a5",
	"./informatyka/games/page019_game1/img/papuga.jpg": "0955",
	"./informatyka/games/page019_game1/img/rak.jpg": "1837",
	"./informatyka/games/page019_game1/img/slon.jpg": "73c8",
	"./informatyka/games/page019_game1/img/t.png": "d6ee",
	"./informatyka/games/page019_game1/img/tulipan.jpg": "6a8a",
	"./informatyka/games/page019_game1/img/ul.jpg": "5e12",
	"./informatyka/games/page019_game1/img/waz.jpg": "d70a",
	"./informatyka/games/page019_game1/img/zegar.jpg": "6c24",
	"./informatyka/games/page019_game10/audio": "c42f",
	"./informatyka/games/page019_game10/audio/": "c42f",
	"./informatyka/games/page019_game10/audio/index": "c42f",
	"./informatyka/games/page019_game10/audio/index.js": "c42f",
	"./informatyka/games/page019_game10/audio/polecenie.mp3": "5e78",
	"./informatyka/games/page019_game10/audio/z9s19-1.mp3": "c3eb",
	"./informatyka/games/page019_game10/audio/z9s19-2.mp3": "f4a0",
	"./informatyka/games/page019_game10/audio/z9s19-3.mp3": "5680",
	"./informatyka/games/page019_game10/audio/z9s19-4.mp3": "3737",
	"./informatyka/games/page019_game10/audio/z9s19-5.mp3": "75bd",
	"./informatyka/games/page019_game10/audio/z9s19-6.mp3": "b506",
	"./informatyka/games/page019_game10/config": "a1cf",
	"./informatyka/games/page019_game10/config.js": "a1cf",
	"./informatyka/games/page019_game10/gameData.config": "a182",
	"./informatyka/games/page019_game10/gameData.config.js": "a182",
	"./informatyka/games/page019_game10/img": "2d06",
	"./informatyka/games/page019_game10/img/": "2d06",
	"./informatyka/games/page019_game10/img/bcg.jpg": "3697",
	"./informatyka/games/page019_game10/img/bcg2.jpg": "ada8",
	"./informatyka/games/page019_game10/img/index": "2d06",
	"./informatyka/games/page019_game10/img/index.js": "2d06",
	"./informatyka/games/page019_game11/audio": "cf10",
	"./informatyka/games/page019_game11/audio/": "cf10",
	"./informatyka/games/page019_game11/audio/index": "cf10",
	"./informatyka/games/page019_game11/audio/index.js": "cf10",
	"./informatyka/games/page019_game11/audio/polecenie.mp3": "7488",
	"./informatyka/games/page019_game11/audio/z9s19-1.mp3": "32e7",
	"./informatyka/games/page019_game11/audio/z9s19-2.mp3": "dc93",
	"./informatyka/games/page019_game11/audio/z9s19-3.mp3": "316e",
	"./informatyka/games/page019_game11/audio/z9s19-4.mp3": "7a777",
	"./informatyka/games/page019_game11/audio/z9s19-5.mp3": "a0c3",
	"./informatyka/games/page019_game11/audio/z9s19-6.mp3": "aa03",
	"./informatyka/games/page019_game11/config": "2293",
	"./informatyka/games/page019_game11/config.js": "2293",
	"./informatyka/games/page019_game11/gameData.config": "474d",
	"./informatyka/games/page019_game11/gameData.config.js": "474d",
	"./informatyka/games/page019_game11/img": "4bd8",
	"./informatyka/games/page019_game11/img/": "4bd8",
	"./informatyka/games/page019_game11/img/bcg.jpg": "bf87",
	"./informatyka/games/page019_game11/img/bcg2.jpg": "c683",
	"./informatyka/games/page019_game11/img/index": "4bd8",
	"./informatyka/games/page019_game11/img/index.js": "4bd8",
	"./informatyka/games/page019_game3/audio": "0df1",
	"./informatyka/games/page019_game3/audio/": "0df1",
	"./informatyka/games/page019_game3/audio/index": "0df1",
	"./informatyka/games/page019_game3/audio/index.js": "0df1",
	"./informatyka/games/page019_game3/audio/klik.mp3": "b8f6",
	"./informatyka/games/page019_game3/audio/z19c3-1.mp3": "ebf1",
	"./informatyka/games/page019_game3/audio/z19c3-2.mp3": "a77a",
	"./informatyka/games/page019_game3/audio/z19c3-3.mp3": "164d",
	"./informatyka/games/page019_game3/audio/z19c3-4.mp3": "10d8",
	"./informatyka/games/page019_game3/audio/z19c3-brawo.mp3": "4e32",
	"./informatyka/games/page019_game3/audio/z19c3.mp3": "bc21",
	"./informatyka/games/page019_game3/config": "ac78",
	"./informatyka/games/page019_game3/config.js": "ac78",
	"./informatyka/games/page019_game3/gameData.config": "5d49",
	"./informatyka/games/page019_game3/gameData.config.js": "5d49",
	"./informatyka/games/page019_game3/img": "4a65",
	"./informatyka/games/page019_game3/img/": "4a65",
	"./informatyka/games/page019_game3/img/00.png": "59fb",
	"./informatyka/games/page019_game3/img/01.png": "4471",
	"./informatyka/games/page019_game3/img/02.png": "a277",
	"./informatyka/games/page019_game3/img/03.png": "0a2e",
	"./informatyka/games/page019_game3/img/10.png": "a9fa",
	"./informatyka/games/page019_game3/img/11.png": "b43a",
	"./informatyka/games/page019_game3/img/12.png": "5505",
	"./informatyka/games/page019_game3/img/13.png": "7d56",
	"./informatyka/games/page019_game3/img/bcg.png": "044d",
	"./informatyka/games/page019_game3/img/index": "4a65",
	"./informatyka/games/page019_game3/img/index.js": "4a65",
	"./informatyka/games/page019_game3/img/point.png": "e2f4",
	"./informatyka/games/page019_game4/audio": "eb7a",
	"./informatyka/games/page019_game4/audio/": "eb7a",
	"./informatyka/games/page019_game4/audio/index": "eb7a",
	"./informatyka/games/page019_game4/audio/index.js": "eb7a",
	"./informatyka/games/page019_game4/audio/klik.mp3": "4938",
	"./informatyka/games/page019_game4/audio/z19c4-brawo.mp3": "453b",
	"./informatyka/games/page019_game4/audio/z19c4.mp3": "6743",
	"./informatyka/games/page019_game4/config": "98ea",
	"./informatyka/games/page019_game4/config.js": "98ea",
	"./informatyka/games/page019_game4/gameData.config": "a224",
	"./informatyka/games/page019_game4/gameData.config.js": "a224",
	"./informatyka/games/page019_game4/img": "9e1d",
	"./informatyka/games/page019_game4/img/": "9e1d",
	"./informatyka/games/page019_game4/img/00.png": "1798",
	"./informatyka/games/page019_game4/img/01.png": "544d",
	"./informatyka/games/page019_game4/img/02.png": "e403",
	"./informatyka/games/page019_game4/img/03.png": "b90e",
	"./informatyka/games/page019_game4/img/04.png": "983e",
	"./informatyka/games/page019_game4/img/05.png": "f7a8",
	"./informatyka/games/page019_game4/img/06.png": "08d3",
	"./informatyka/games/page019_game4/img/10.png": "093b",
	"./informatyka/games/page019_game4/img/bgr.png": "ce22",
	"./informatyka/games/page019_game4/img/index": "9e1d",
	"./informatyka/games/page019_game4/img/index.js": "9e1d",
	"./informatyka/games/page020_game1/audio": "e053",
	"./informatyka/games/page020_game1/audio/": "e053",
	"./informatyka/games/page020_game1/audio/f.mp3": "e291",
	"./informatyka/games/page020_game1/audio/index": "e053",
	"./informatyka/games/page020_game1/audio/index.js": "e053",
	"./informatyka/games/page020_game1/audio/t.mp3": "d354",
	"./informatyka/games/page020_game1/audio/z20c1-brawo.mp3": "c9b3",
	"./informatyka/games/page020_game1/audio/z20c1.mp3": "559e",
	"./informatyka/games/page020_game1/config": "f577",
	"./informatyka/games/page020_game1/config.js": "f577",
	"./informatyka/games/page020_game1/gameData.config": "a791",
	"./informatyka/games/page020_game1/gameData.config.js": "a791",
	"./informatyka/games/page020_game1/img": "3782",
	"./informatyka/games/page020_game1/img/": "3782",
	"./informatyka/games/page020_game1/img/0.png": "b2a9",
	"./informatyka/games/page020_game1/img/1.png": "892e",
	"./informatyka/games/page020_game1/img/2.png": "9502",
	"./informatyka/games/page020_game1/img/3.png": "b994",
	"./informatyka/games/page020_game1/img/4.png": "1794",
	"./informatyka/games/page020_game1/img/5.png": "95f0",
	"./informatyka/games/page020_game1/img/6.png": "0649",
	"./informatyka/games/page020_game1/img/7.png": "6716",
	"./informatyka/games/page020_game1/img/8.png": "8914",
	"./informatyka/games/page020_game1/img/9.png": "ee33",
	"./informatyka/games/page020_game1/img/bcg.png": "6736",
	"./informatyka/games/page020_game1/img/f.png": "5708",
	"./informatyka/games/page020_game1/img/index": "3782",
	"./informatyka/games/page020_game1/img/index.js": "3782",
	"./informatyka/games/page020_game1/img/t.png": "40f2",
	"./informatyka/games/page020_game2/audio": "00a0",
	"./informatyka/games/page020_game2/audio/": "00a0",
	"./informatyka/games/page020_game2/audio/index": "00a0",
	"./informatyka/games/page020_game2/audio/index.js": "00a0",
	"./informatyka/games/page020_game2/audio/z20c2-brawo.mp3": "2f40",
	"./informatyka/games/page020_game2/audio/z20c2.mp3": "54ec",
	"./informatyka/games/page020_game2/config": "5082",
	"./informatyka/games/page020_game2/config.js": "5082",
	"./informatyka/games/page020_game2/gameData.config": "991d",
	"./informatyka/games/page020_game2/gameData.config.js": "991d",
	"./informatyka/games/page020_game2/img": "d9b1",
	"./informatyka/games/page020_game2/img/": "d9b1",
	"./informatyka/games/page020_game2/img/00.png": "51c8",
	"./informatyka/games/page020_game2/img/01.png": "6bc7",
	"./informatyka/games/page020_game2/img/02.png": "ee4f",
	"./informatyka/games/page020_game2/img/03.png": "7f89",
	"./informatyka/games/page020_game2/img/04.png": "447d",
	"./informatyka/games/page020_game2/img/05.png": "a7cf",
	"./informatyka/games/page020_game2/img/bcg.png": "abc1",
	"./informatyka/games/page020_game2/img/index": "d9b1",
	"./informatyka/games/page020_game2/img/index.js": "d9b1",
	"./informatyka/games/page020_game3/audio": "6689",
	"./informatyka/games/page020_game3/audio/": "6689",
	"./informatyka/games/page020_game3/audio/index": "6689",
	"./informatyka/games/page020_game3/audio/index.js": "6689",
	"./informatyka/games/page020_game3/audio/klik.mp3": "1020",
	"./informatyka/games/page020_game3/audio/z20c3-brawo.mp3": "6880",
	"./informatyka/games/page020_game3/audio/z20c3.mp3": "9ca4",
	"./informatyka/games/page020_game3/config": "5c08",
	"./informatyka/games/page020_game3/config.js": "5c08",
	"./informatyka/games/page020_game3/gameData.config": "d740",
	"./informatyka/games/page020_game3/gameData.config.js": "d740",
	"./informatyka/games/page020_game3/img": "c589",
	"./informatyka/games/page020_game3/img/": "c589",
	"./informatyka/games/page020_game3/img/bgr.png": "e0323",
	"./informatyka/games/page020_game3/img/index": "c589",
	"./informatyka/games/page020_game3/img/index.js": "c589",
	"./informatyka/games/page021_game1/audio": "b03b",
	"./informatyka/games/page021_game1/audio/": "b03b",
	"./informatyka/games/page021_game1/audio/index": "b03b",
	"./informatyka/games/page021_game1/audio/index.js": "b03b",
	"./informatyka/games/page021_game1/audio/z21s42-1.mp3": "5c95",
	"./informatyka/games/page021_game1/audio/z21s42-2.mp3": "51dc",
	"./informatyka/games/page021_game1/audio/z21s42-polecenie.mp3": "08c4",
	"./informatyka/games/page021_game1/config": "e41e",
	"./informatyka/games/page021_game1/config.js": "e41e",
	"./informatyka/games/page021_game1/gameData.config": "2c37",
	"./informatyka/games/page021_game1/gameData.config.js": "2c37",
	"./informatyka/games/page021_game1/img": "97c2",
	"./informatyka/games/page021_game1/img/": "97c2",
	"./informatyka/games/page021_game1/img/00.jpg": "9255",
	"./informatyka/games/page021_game1/img/01.jpg": "f1c5",
	"./informatyka/games/page021_game1/img/02.jpg": "5f7c",
	"./informatyka/games/page021_game1/img/index": "97c2",
	"./informatyka/games/page021_game1/img/index.js": "97c2",
	"./informatyka/games/page021_game10/audio": "d2e9",
	"./informatyka/games/page021_game10/audio/": "d2e9",
	"./informatyka/games/page021_game10/audio/index": "d2e9",
	"./informatyka/games/page021_game10/audio/index.js": "d2e9",
	"./informatyka/games/page021_game10/audio/polecenie.mp3": "d189",
	"./informatyka/games/page021_game10/audio/z10s21-a1.mp3": "29e6",
	"./informatyka/games/page021_game10/audio/z10s21-a2.mp3": "237b",
	"./informatyka/games/page021_game10/audio/z10s21-b1.mp3": "7057",
	"./informatyka/games/page021_game10/audio/z10s21-b3.mp3": "5fc4",
	"./informatyka/games/page021_game10/audio/z10s21-b4.mp3": "a687",
	"./informatyka/games/page021_game10/config": "24dc",
	"./informatyka/games/page021_game10/config.js": "24dc",
	"./informatyka/games/page021_game10/gameData.config": "d536",
	"./informatyka/games/page021_game10/gameData.config.js": "d536",
	"./informatyka/games/page021_game10/img": "0df5",
	"./informatyka/games/page021_game10/img/": "0df5",
	"./informatyka/games/page021_game10/img/bcg.jpg": "c72a",
	"./informatyka/games/page021_game10/img/index": "0df5",
	"./informatyka/games/page021_game10/img/index.js": "0df5",
	"./informatyka/games/page021_game11/audio": "37a1",
	"./informatyka/games/page021_game11/audio/": "37a1",
	"./informatyka/games/page021_game11/audio/index": "37a1",
	"./informatyka/games/page021_game11/audio/index.js": "37a1",
	"./informatyka/games/page021_game11/config": "682c",
	"./informatyka/games/page021_game11/config.js": "682c",
	"./informatyka/games/page021_game11/gameData.config": "91ad",
	"./informatyka/games/page021_game11/gameData.config.js": "91ad",
	"./informatyka/games/page021_game11/img": "c921",
	"./informatyka/games/page021_game11/img/": "c921",
	"./informatyka/games/page021_game11/img/bcg.jpg": "b78e",
	"./informatyka/games/page021_game11/img/index": "c921",
	"./informatyka/games/page021_game11/img/index.js": "c921",
	"./informatyka/games/page021_game4/audio": "4473",
	"./informatyka/games/page021_game4/audio/": "4473",
	"./informatyka/games/page021_game4/audio/index": "4473",
	"./informatyka/games/page021_game4/audio/index.js": "4473",
	"./informatyka/games/page021_game4/audio/z21c4-brawo.mp3": "5e1a",
	"./informatyka/games/page021_game4/audio/z21c4.mp3": "05b1",
	"./informatyka/games/page021_game4/config": "747a",
	"./informatyka/games/page021_game4/config.js": "747a",
	"./informatyka/games/page021_game4/gameData.config": "e7dc",
	"./informatyka/games/page021_game4/gameData.config.js": "e7dc",
	"./informatyka/games/page021_game4/img": "79a3",
	"./informatyka/games/page021_game4/img/": "79a3",
	"./informatyka/games/page021_game4/img/1.png": "48f1",
	"./informatyka/games/page021_game4/img/2.png": "c639",
	"./informatyka/games/page021_game4/img/3.png": "c451",
	"./informatyka/games/page021_game4/img/4.png": "11e2",
	"./informatyka/games/page021_game4/img/5.png": "70f6",
	"./informatyka/games/page021_game4/img/6.png": "be60",
	"./informatyka/games/page021_game4/img/7.png": "5e31",
	"./informatyka/games/page021_game4/img/bcg.png": "28c9",
	"./informatyka/games/page021_game4/img/index": "79a3",
	"./informatyka/games/page021_game4/img/index.js": "79a3",
	"./informatyka/games/page022_game3/audio": "8d91",
	"./informatyka/games/page022_game3/audio/": "8d91",
	"./informatyka/games/page022_game3/audio/index": "8d91",
	"./informatyka/games/page022_game3/audio/index.js": "8d91",
	"./informatyka/games/page022_game3/audio/klik.mp3": "2457",
	"./informatyka/games/page022_game3/audio/z22c3-1.mp3": "e2e7",
	"./informatyka/games/page022_game3/audio/z22c3-2.mp3": "435a",
	"./informatyka/games/page022_game3/audio/z22c3-3.mp3": "36b7",
	"./informatyka/games/page022_game3/audio/z22c3-brawo.mp3": "3742",
	"./informatyka/games/page022_game3/audio/z22c3.mp3": "1e8a",
	"./informatyka/games/page022_game3/config": "b55b",
	"./informatyka/games/page022_game3/config.js": "b55b",
	"./informatyka/games/page022_game3/gameData.config": "81fa",
	"./informatyka/games/page022_game3/gameData.config.js": "81fa",
	"./informatyka/games/page022_game3/img": "f38c",
	"./informatyka/games/page022_game3/img/": "f38c",
	"./informatyka/games/page022_game3/img/00.png": "e4f3",
	"./informatyka/games/page022_game3/img/01.png": "d72d",
	"./informatyka/games/page022_game3/img/02.png": "4f59",
	"./informatyka/games/page022_game3/img/0p.png": "fc85",
	"./informatyka/games/page022_game3/img/10.png": "bbc1",
	"./informatyka/games/page022_game3/img/11.png": "04af",
	"./informatyka/games/page022_game3/img/12.png": "3d4b",
	"./informatyka/games/page022_game3/img/1p.png": "ca08",
	"./informatyka/games/page022_game3/img/bcg.png": "cc8f",
	"./informatyka/games/page022_game3/img/index": "f38c",
	"./informatyka/games/page022_game3/img/index.js": "f38c",
	"./informatyka/games/page023_game1/audio": "ad38",
	"./informatyka/games/page023_game1/audio/": "ad38",
	"./informatyka/games/page023_game1/audio/f.mp3": "a6a6",
	"./informatyka/games/page023_game1/audio/index": "ad38",
	"./informatyka/games/page023_game1/audio/index.js": "ad38",
	"./informatyka/games/page023_game1/audio/t.mp3": "8bd6",
	"./informatyka/games/page023_game1/audio/z23c1-brawo.mp3": "fbba",
	"./informatyka/games/page023_game1/audio/z23c1-jeszcze-raz.mp3": "cdfa",
	"./informatyka/games/page023_game1/audio/z23c1.mp3": "e9a5",
	"./informatyka/games/page023_game1/config": "4452",
	"./informatyka/games/page023_game1/config.js": "4452",
	"./informatyka/games/page023_game1/gameData.config": "89ad",
	"./informatyka/games/page023_game1/gameData.config.js": "89ad",
	"./informatyka/games/page023_game1/img": "9a2d",
	"./informatyka/games/page023_game1/img/": "9a2d",
	"./informatyka/games/page023_game1/img/00.png": "af61",
	"./informatyka/games/page023_game1/img/01.png": "cf8f",
	"./informatyka/games/page023_game1/img/02.png": "01f4",
	"./informatyka/games/page023_game1/img/03.png": "af29",
	"./informatyka/games/page023_game1/img/04.png": "3e8b",
	"./informatyka/games/page023_game1/img/05.png": "58b5",
	"./informatyka/games/page023_game1/img/06.png": "e627",
	"./informatyka/games/page023_game1/img/07.png": "9ac9",
	"./informatyka/games/page023_game1/img/08.png": "93c5",
	"./informatyka/games/page023_game1/img/bcg.png": "b702",
	"./informatyka/games/page023_game1/img/f.png": "3fc3",
	"./informatyka/games/page023_game1/img/index": "9a2d",
	"./informatyka/games/page023_game1/img/index.js": "9a2d",
	"./informatyka/games/page023_game1/img/t.png": "bae2",
	"./informatyka/games/page024_game1/audio": "1a95",
	"./informatyka/games/page024_game1/audio/": "1a95",
	"./informatyka/games/page024_game1/audio/index": "1a95",
	"./informatyka/games/page024_game1/audio/index.js": "1a95",
	"./informatyka/games/page024_game1/audio/klik.mp3": "850e",
	"./informatyka/games/page024_game1/audio/z24c1-1.mp3": "81dd",
	"./informatyka/games/page024_game1/audio/z24c1-2.mp3": "f658",
	"./informatyka/games/page024_game1/audio/z24c1-3.mp3": "8178",
	"./informatyka/games/page024_game1/audio/z24c1-brawo.mp3": "b6d3",
	"./informatyka/games/page024_game1/audio/z24c1.mp3": "605c",
	"./informatyka/games/page024_game1/config": "7a15",
	"./informatyka/games/page024_game1/config.js": "7a15",
	"./informatyka/games/page024_game1/gameData.config": "a988",
	"./informatyka/games/page024_game1/gameData.config.js": "a988",
	"./informatyka/games/page024_game1/img": "1864",
	"./informatyka/games/page024_game1/img/": "1864",
	"./informatyka/games/page024_game1/img/00.png": "9382",
	"./informatyka/games/page024_game1/img/01.png": "6014",
	"./informatyka/games/page024_game1/img/02.png": "91b3",
	"./informatyka/games/page024_game1/img/0p.png": "2f88",
	"./informatyka/games/page024_game1/img/10.png": "6e6f",
	"./informatyka/games/page024_game1/img/11.png": "621c",
	"./informatyka/games/page024_game1/img/12.png": "5217",
	"./informatyka/games/page024_game1/img/1p.png": "d88b",
	"./informatyka/games/page024_game1/img/24_ćw1.png": "1606",
	"./informatyka/games/page024_game1/img/index": "1864",
	"./informatyka/games/page024_game1/img/index.js": "1864",
	"./informatyka/games/page024_game10/audio": "dcc9",
	"./informatyka/games/page024_game10/audio/": "dcc9",
	"./informatyka/games/page024_game10/audio/index": "dcc9",
	"./informatyka/games/page024_game10/audio/index.js": "dcc9",
	"./informatyka/games/page024_game10/audio/polecenie.mp3": "ea74",
	"./informatyka/games/page024_game10/audio/z12s24-1.mp3": "964e",
	"./informatyka/games/page024_game10/audio/z12s24-2.mp3": "18e9",
	"./informatyka/games/page024_game10/audio/z12s24-3.mp3": "b8e1",
	"./informatyka/games/page024_game10/audio/z12s24-3b.mp3": "4497",
	"./informatyka/games/page024_game10/audio/z12s24-4.mp3": "2ac6",
	"./informatyka/games/page024_game10/audio/z12s24-5.mp3": "243c",
	"./informatyka/games/page024_game10/config": "2d6f",
	"./informatyka/games/page024_game10/config.js": "2d6f",
	"./informatyka/games/page024_game10/gameData.config": "0f04",
	"./informatyka/games/page024_game10/gameData.config.js": "0f04",
	"./informatyka/games/page024_game10/img": "1546",
	"./informatyka/games/page024_game10/img/": "1546",
	"./informatyka/games/page024_game10/img/bcg.jpg": "681c",
	"./informatyka/games/page024_game10/img/index": "1546",
	"./informatyka/games/page024_game10/img/index.js": "1546",
	"./informatyka/games/page025_game1/audio": "8b72",
	"./informatyka/games/page025_game1/audio/": "8b72",
	"./informatyka/games/page025_game1/audio/index": "8b72",
	"./informatyka/games/page025_game1/audio/index.js": "8b72",
	"./informatyka/games/page025_game1/audio/klik.mp3": "2d91",
	"./informatyka/games/page025_game1/audio/z25c1-brawo.mp3": "89db",
	"./informatyka/games/page025_game1/audio/z25c1.mp3": "a668",
	"./informatyka/games/page025_game1/config": "63fb",
	"./informatyka/games/page025_game1/config.js": "63fb",
	"./informatyka/games/page025_game1/gameData.config": "cba1",
	"./informatyka/games/page025_game1/gameData.config.js": "cba1",
	"./informatyka/games/page025_game1/img": "37cb",
	"./informatyka/games/page025_game1/img/": "37cb",
	"./informatyka/games/page025_game1/img/00.jpg": "784d",
	"./informatyka/games/page025_game1/img/01.jpg": "689d",
	"./informatyka/games/page025_game1/img/02.jpg": "2e0d",
	"./informatyka/games/page025_game1/img/03.jpg": "1d3b",
	"./informatyka/games/page025_game1/img/bgr.png": "288a",
	"./informatyka/games/page025_game1/img/index": "37cb",
	"./informatyka/games/page025_game1/img/index.js": "37cb",
	"./informatyka/games/page025_game1/img/plansza.png": "bc29",
	"./informatyka/games/page025_game1/img/plansza_old.png": "d190",
	"./informatyka/games/page025_game10/audio": "9504",
	"./informatyka/games/page025_game10/audio/": "9504",
	"./informatyka/games/page025_game10/audio/index": "9504",
	"./informatyka/games/page025_game10/audio/index.js": "9504",
	"./informatyka/games/page025_game10/audio/polecenie.mp3": "c1ee",
	"./informatyka/games/page025_game10/audio/z12s25-1.mp3": "9dcf",
	"./informatyka/games/page025_game10/audio/z12s25-2.mp3": "f876",
	"./informatyka/games/page025_game10/audio/z12s25-3.mp3": "d3b4",
	"./informatyka/games/page025_game10/config": "5a55",
	"./informatyka/games/page025_game10/config.js": "5a55",
	"./informatyka/games/page025_game10/gameData.config": "9533",
	"./informatyka/games/page025_game10/gameData.config.js": "9533",
	"./informatyka/games/page025_game10/img": "e405",
	"./informatyka/games/page025_game10/img/": "e405",
	"./informatyka/games/page025_game10/img/bcg.jpg": "c0df",
	"./informatyka/games/page025_game10/img/index": "e405",
	"./informatyka/games/page025_game10/img/index.js": "e405",
	"./informatyka/games/page025_game2/audio": "0054",
	"./informatyka/games/page025_game2/audio/": "0054",
	"./informatyka/games/page025_game2/audio/index": "0054",
	"./informatyka/games/page025_game2/audio/index.js": "0054",
	"./informatyka/games/page025_game2/audio/z25s50-1.mp3": "ab3d",
	"./informatyka/games/page025_game2/audio/z25s50-2.mp3": "18be",
	"./informatyka/games/page025_game2/audio/z25s50-polecenie.mp3": "77a8",
	"./informatyka/games/page025_game2/config": "9a78",
	"./informatyka/games/page025_game2/config.js": "9a78",
	"./informatyka/games/page025_game2/gameData.config": "3afb",
	"./informatyka/games/page025_game2/gameData.config.js": "3afb",
	"./informatyka/games/page025_game2/img": "bdbd",
	"./informatyka/games/page025_game2/img/": "bdbd",
	"./informatyka/games/page025_game2/img/00.jpg": "9cbd",
	"./informatyka/games/page025_game2/img/01.jpg": "fabd",
	"./informatyka/games/page025_game2/img/index": "bdbd",
	"./informatyka/games/page025_game2/img/index.js": "bdbd",
	"./informatyka/games/page026_game1/audio": "e551",
	"./informatyka/games/page026_game1/audio/": "e551",
	"./informatyka/games/page026_game1/audio/index": "e551",
	"./informatyka/games/page026_game1/audio/index.js": "e551",
	"./informatyka/games/page026_game1/audio/test.mp3": "2f07",
	"./informatyka/games/page026_game1/audio/z26c1-brawo.mp3": "9dcd",
	"./informatyka/games/page026_game1/audio/z26c1.mp3": "d356",
	"./informatyka/games/page026_game1/config": "217c",
	"./informatyka/games/page026_game1/config.js": "217c",
	"./informatyka/games/page026_game1/gameData.config": "783d",
	"./informatyka/games/page026_game1/gameData.config.js": "783d",
	"./informatyka/games/page026_game1/img": "9e7c",
	"./informatyka/games/page026_game1/img/": "9e7c",
	"./informatyka/games/page026_game1/img/01folder.png": "9f76",
	"./informatyka/games/page026_game1/img/01kursor.png": "ebf6",
	"./informatyka/games/page026_game1/img/01zamknij.png": "969c",
	"./informatyka/games/page026_game1/img/021.png": "f8a7",
	"./informatyka/games/page026_game1/img/022.png": "4694",
	"./informatyka/games/page026_game1/img/023.png": "9855",
	"./informatyka/games/page026_game1/img/03jednostka.png": "07e5",
	"./informatyka/games/page026_game1/img/03klawiatura.png": "09f3",
	"./informatyka/games/page026_game1/img/03monitor.png": "ed80",
	"./informatyka/games/page026_game1/img/04paint.png": "ce77",
	"./informatyka/games/page026_game1/img/04scratch.png": "46d1",
	"./informatyka/games/page026_game1/img/04word.png": "f45a",
	"./informatyka/games/page026_game1/img/05gumka.png": "7679",
	"./informatyka/games/page026_game1/img/05lupa.png": "1e8c",
	"./informatyka/games/page026_game1/img/05wypelniijkolorem.png": "76ef",
	"./informatyka/games/page026_game1/img/06gumka.png": "708e",
	"./informatyka/games/page026_game1/img/06ołówek.png": "ff04",
	"./informatyka/games/page026_game1/img/06zaznacz.png": "bf2f",
	"./informatyka/games/page026_game1/img/08ctrlC.png": "b2bb",
	"./informatyka/games/page026_game1/img/08ctrlV.png": "4487",
	"./informatyka/games/page026_game1/img/08enter.png": "bc98",
	"./informatyka/games/page026_game1/img/09gumka.png": "3fde",
	"./informatyka/games/page026_game1/img/09owal.png": "9852",
	"./informatyka/games/page026_game1/img/09prostokąt.png": "26f6",
	"./informatyka/games/page026_game1/img/10koło2D.png": "6b0c",
	"./informatyka/games/page026_game1/img/10kula3D.png": "56a2",
	"./informatyka/games/page026_game1/img/10kwadrat2D.png": "72a9",
	"./informatyka/games/page026_game1/img/11kołotrojkatprostokat.png": "b35b",
	"./informatyka/games/page026_game1/img/11kulastozek.png": "5342",
	"./informatyka/games/page026_game1/img/11szescianprostopadloscian.png": "ab57",
	"./informatyka/games/page026_game1/img/12gumka.png": "6ee1",
	"./informatyka/games/page026_game1/img/12pedzel.png": "c4d9",
	"./informatyka/games/page026_game1/img/12wypelniijkolorem.png": "1288",
	"./informatyka/games/page026_game1/img/13lupa.png": "2fdf",
	"./informatyka/games/page026_game1/img/13ołówek.png": "db37",
	"./informatyka/games/page026_game1/img/13tekst.png": "994f",
	"./informatyka/games/page026_game1/img/14kalkulator.png": "1044",
	"./informatyka/games/page026_game1/img/14paint.png": "6058",
	"./informatyka/games/page026_game1/img/14word.png": "5f1c",
	"./informatyka/games/page026_game1/img/16capsLock.png": "cd09",
	"./informatyka/games/page026_game1/img/16enter.png": "a93c",
	"./informatyka/games/page026_game1/img/16spacja.png": "f278",
	"./informatyka/games/page026_game1/img/17alt.png": "e515",
	"./informatyka/games/page026_game1/img/17enter.png": "c021",
	"./informatyka/games/page026_game1/img/17shift.png": "5886",
	"./informatyka/games/page026_game1/img/19enter.png": "c9d4",
	"./informatyka/games/page026_game1/img/19shift.png": "ebcf",
	"./informatyka/games/page026_game1/img/19spacja.png": "2c27",
	"./informatyka/games/page026_game1/img/20mysz.png": "fda3",
	"./informatyka/games/page026_game1/img/20pies.png": "1cbe",
	"./informatyka/games/page026_game1/img/20scratch.png": "510a",
	"./informatyka/games/page026_game1/img/c.png": "feb1",
	"./informatyka/games/page026_game1/img/ctrl.png": "a19d",
	"./informatyka/games/page026_game1/img/index": "9e7c",
	"./informatyka/games/page026_game1/img/index.js": "9e7c",
	"./informatyka/games/page026_game1/img/v.png": "a50c",
	"./informatyka/games/page026_game10/audio": "7af9",
	"./informatyka/games/page026_game10/audio/": "7af9",
	"./informatyka/games/page026_game10/audio/index": "7af9",
	"./informatyka/games/page026_game10/audio/index.js": "7af9",
	"./informatyka/games/page026_game10/audio/polecenie.mp3": "f615",
	"./informatyka/games/page026_game10/audio/z13s26-1.mp3": "1195",
	"./informatyka/games/page026_game10/audio/z13s26-2.mp3": "d680",
	"./informatyka/games/page026_game10/audio/z13s26-3.mp3": "af0e",
	"./informatyka/games/page026_game10/audio/z13s26-3b.mp3": "59c7",
	"./informatyka/games/page026_game10/audio/z13s26-4.mp3": "693b",
	"./informatyka/games/page026_game10/audio/z13s26-5.mp3": "8abe",
	"./informatyka/games/page026_game10/config": "7f66",
	"./informatyka/games/page026_game10/config.js": "7f66",
	"./informatyka/games/page026_game10/gameData.config": "d28b",
	"./informatyka/games/page026_game10/gameData.config.js": "d28b",
	"./informatyka/games/page026_game10/img": "e836",
	"./informatyka/games/page026_game10/img/": "e836",
	"./informatyka/games/page026_game10/img/bcg.jpg": "f63d",
	"./informatyka/games/page026_game10/img/index": "e836",
	"./informatyka/games/page026_game10/img/index.js": "e836",
	"./informatyka/games/page026_game4/audio": "eda9",
	"./informatyka/games/page026_game4/audio/": "eda9",
	"./informatyka/games/page026_game4/audio/index": "eda9",
	"./informatyka/games/page026_game4/audio/index.js": "eda9",
	"./informatyka/games/page026_game4/audio/z26c4-brawo.mp3": "4816",
	"./informatyka/games/page026_game4/audio/z26c4.mp3": "fe34",
	"./informatyka/games/page026_game4/config": "3247",
	"./informatyka/games/page026_game4/config.js": "3247",
	"./informatyka/games/page026_game4/gameData.config": "2600",
	"./informatyka/games/page026_game4/gameData.config.js": "2600",
	"./informatyka/games/page026_game4/img": "840d",
	"./informatyka/games/page026_game4/img/": "840d",
	"./informatyka/games/page026_game4/img/index": "840d",
	"./informatyka/games/page026_game4/img/index.js": "840d",
	"./informatyka/games/page026_game4/img/plansza.png": "c923",
	"./informatyka/games/page027_game1/audio": "2e85",
	"./informatyka/games/page027_game1/audio/": "2e85",
	"./informatyka/games/page027_game1/audio/index": "2e85",
	"./informatyka/games/page027_game1/audio/index.js": "2e85",
	"./informatyka/games/page027_game1/audio/z26c4-brawo.mp3": "9bd3",
	"./informatyka/games/page027_game1/audio/z27c1.mp3": "6383",
	"./informatyka/games/page027_game1/config": "0304",
	"./informatyka/games/page027_game1/config.js": "0304",
	"./informatyka/games/page027_game1/gameData.config": "6feb",
	"./informatyka/games/page027_game1/gameData.config.js": "6feb",
	"./informatyka/games/page027_game1/img": "43e7",
	"./informatyka/games/page027_game1/img/": "43e7",
	"./informatyka/games/page027_game1/img/00.png": "1fb9",
	"./informatyka/games/page027_game1/img/01.png": "f403",
	"./informatyka/games/page027_game1/img/02.png": "d7e0",
	"./informatyka/games/page027_game1/img/03.png": "c2d0",
	"./informatyka/games/page027_game1/img/04.png": "bcb3",
	"./informatyka/games/page027_game1/img/05.png": "ee3b",
	"./informatyka/games/page027_game1/img/06.png": "efea",
	"./informatyka/games/page027_game1/img/07.png": "6682",
	"./informatyka/games/page027_game1/img/77.png": "1cf3",
	"./informatyka/games/page027_game1/img/88.png": "0564",
	"./informatyka/games/page027_game1/img/99.png": "0979",
	"./informatyka/games/page027_game1/img/ctrl.png": "8572",
	"./informatyka/games/page027_game1/img/index": "43e7",
	"./informatyka/games/page027_game1/img/index.js": "43e7",
	"./informatyka/games/page027_game1/img/v.png": "730b",
	"./informatyka/games/page027_game8/audio": "7afc",
	"./informatyka/games/page027_game8/audio/": "7afc",
	"./informatyka/games/page027_game8/audio/index": "7afc",
	"./informatyka/games/page027_game8/audio/index.js": "7afc",
	"./informatyka/games/page027_game8/audio/z27c2-3.mp3": "4a06",
	"./informatyka/games/page027_game8/audio/z3c2.mp3": "2742",
	"./informatyka/games/page027_game8/config": "d8d0",
	"./informatyka/games/page027_game8/config.js": "d8d0",
	"./informatyka/games/page027_game8/gameData.config": "359a",
	"./informatyka/games/page027_game8/gameData.config.js": "359a",
	"./informatyka/games/page027_game8/img": "369f",
	"./informatyka/games/page027_game8/img/": "369f",
	"./informatyka/games/page027_game8/img/56969_0_dzieci na plazy_original127.png": "b24b",
	"./informatyka/games/page027_game8/img/56969_0_dzieci na plazy_original127_out.png": "a6c3",
	"./informatyka/games/page027_game8/img/56969_0_dzieci na plazy_original_tr.png": "1c23",
	"./informatyka/games/page027_game8/img/index": "369f",
	"./informatyka/games/page027_game8/img/index.js": "369f",
	"./informatyka/games/page027_game8/img/paleta_raster.png": "5e6a",
	"./informatyka/games/page027_game9/audio": "71c7",
	"./informatyka/games/page027_game9/audio/": "71c7",
	"./informatyka/games/page027_game9/audio/index": "71c7",
	"./informatyka/games/page027_game9/audio/index.js": "71c7",
	"./informatyka/games/page027_game9/audio/z27c2-3.mp3": "eed1",
	"./informatyka/games/page027_game9/audio/z3c2.mp3": "ab97",
	"./informatyka/games/page027_game9/config": "0f83",
	"./informatyka/games/page027_game9/config.js": "0f83",
	"./informatyka/games/page027_game9/gameData.config": "3e0f",
	"./informatyka/games/page027_game9/gameData.config.js": "3e0f",
	"./informatyka/games/page027_game9/img": "618a",
	"./informatyka/games/page027_game9/img/": "618a",
	"./informatyka/games/page027_game9/img/56970_0_dziecko z psem gory_original115.png": "daa9",
	"./informatyka/games/page027_game9/img/56970_0_dziecko z psem gory_original115_out.png": "b773",
	"./informatyka/games/page027_game9/img/56970_0_dziecko z psem gory_original_tr.png": "b3d2",
	"./informatyka/games/page027_game9/img/index": "618a",
	"./informatyka/games/page027_game9/img/index.js": "618a",
	"./informatyka/games/page027_game9/img/paleta_raster.png": "7727",
	"./informatyka/games/page029_game10/audio": "2448",
	"./informatyka/games/page029_game10/audio/": "2448",
	"./informatyka/games/page029_game10/audio/index": "2448",
	"./informatyka/games/page029_game10/audio/index.js": "2448",
	"./informatyka/games/page029_game10/audio/polecenie.mp3": "20fb",
	"./informatyka/games/page029_game10/audio/z14s29-1.mp3": "6a0f",
	"./informatyka/games/page029_game10/audio/z14s29-2.mp3": "04b2",
	"./informatyka/games/page029_game10/audio/z14s29-3.mp3": "c721",
	"./informatyka/games/page029_game10/audio/z14s29-4.mp3": "2524",
	"./informatyka/games/page029_game10/audio/z14s29-5.mp3": "3973",
	"./informatyka/games/page029_game10/audio/z14s29-6.mp3": "9854",
	"./informatyka/games/page029_game10/audio/z14s29-7.mp3": "35ce",
	"./informatyka/games/page029_game10/config": "7542",
	"./informatyka/games/page029_game10/config.js": "7542",
	"./informatyka/games/page029_game10/gameData.config": "2623",
	"./informatyka/games/page029_game10/gameData.config.js": "2623",
	"./informatyka/games/page029_game10/img": "28cb",
	"./informatyka/games/page029_game10/img/": "28cb",
	"./informatyka/games/page029_game10/img/bcg.jpg": "b488",
	"./informatyka/games/page029_game10/img/bcg2.jpg": "b414",
	"./informatyka/games/page029_game10/img/index": "28cb",
	"./informatyka/games/page029_game10/img/index.js": "28cb",
	"./informatyka/games/page029_game11/audio": "5c56",
	"./informatyka/games/page029_game11/audio/": "5c56",
	"./informatyka/games/page029_game11/audio/index": "5c56",
	"./informatyka/games/page029_game11/audio/index.js": "5c56",
	"./informatyka/games/page029_game11/config": "67bf",
	"./informatyka/games/page029_game11/config.js": "67bf",
	"./informatyka/games/page029_game11/gameData.config": "98cb",
	"./informatyka/games/page029_game11/gameData.config.js": "98cb",
	"./informatyka/games/page029_game11/img": "e5c7",
	"./informatyka/games/page029_game11/img/": "e5c7",
	"./informatyka/games/page029_game11/img/bcg.jpg": "9073",
	"./informatyka/games/page029_game11/img/index": "e5c7",
	"./informatyka/games/page029_game11/img/index.js": "e5c7",
	"./informatyka/games/page030_game10/audio": "5397",
	"./informatyka/games/page030_game10/audio/": "5397",
	"./informatyka/games/page030_game10/audio/index": "5397",
	"./informatyka/games/page030_game10/audio/index.js": "5397",
	"./informatyka/games/page030_game10/audio/polecenie.mp3": "d1f7",
	"./informatyka/games/page030_game10/audio/z15s30-1.mp3": "e913",
	"./informatyka/games/page030_game10/audio/z15s30-2.mp3": "0b90",
	"./informatyka/games/page030_game10/config": "1962",
	"./informatyka/games/page030_game10/config.js": "1962",
	"./informatyka/games/page030_game10/gameData.config": "caa9",
	"./informatyka/games/page030_game10/gameData.config.js": "caa9",
	"./informatyka/games/page030_game10/img": "011f",
	"./informatyka/games/page030_game10/img/": "011f",
	"./informatyka/games/page030_game10/img/bcg.jpg": "74fe",
	"./informatyka/games/page030_game10/img/index": "011f",
	"./informatyka/games/page030_game10/img/index.js": "011f",
	"./informatyka/games/page031_game10/audio": "e7e7",
	"./informatyka/games/page031_game10/audio/": "e7e7",
	"./informatyka/games/page031_game10/audio/index": "e7e7",
	"./informatyka/games/page031_game10/audio/index.js": "e7e7",
	"./informatyka/games/page031_game10/audio/polecenie.mp3": "1a1d",
	"./informatyka/games/page031_game10/audio/z15s31-1.mp3": "079b",
	"./informatyka/games/page031_game10/audio/z15s31-2.mp3": "9ee5",
	"./informatyka/games/page031_game10/audio/z15s31-3.mp3": "b3d7",
	"./informatyka/games/page031_game10/audio/z15s31-4.mp3": "49b9",
	"./informatyka/games/page031_game10/config": "9b0a",
	"./informatyka/games/page031_game10/config.js": "9b0a",
	"./informatyka/games/page031_game10/gameData.config": "dca1",
	"./informatyka/games/page031_game10/gameData.config.js": "dca1",
	"./informatyka/games/page031_game10/img": "1985",
	"./informatyka/games/page031_game10/img/": "1985",
	"./informatyka/games/page031_game10/img/bcg.jpg": "bdbb",
	"./informatyka/games/page031_game10/img/index": "1985",
	"./informatyka/games/page031_game10/img/index.js": "1985",
	"./informatyka/games/page031_game11/audio": "d8b6",
	"./informatyka/games/page031_game11/audio/": "d8b6",
	"./informatyka/games/page031_game11/audio/index": "d8b6",
	"./informatyka/games/page031_game11/audio/index.js": "d8b6",
	"./informatyka/games/page031_game11/audio/polecenie.mp3": "3058",
	"./informatyka/games/page031_game11/audio/z15s31-1.mp3": "62ce",
	"./informatyka/games/page031_game11/audio/z15s31-2.mp3": "6417",
	"./informatyka/games/page031_game11/audio/z15s31-3.mp3": "aa84",
	"./informatyka/games/page031_game11/audio/z15s31-4.mp3": "ad16",
	"./informatyka/games/page031_game11/config": "a466",
	"./informatyka/games/page031_game11/config.js": "a466",
	"./informatyka/games/page031_game11/gameData.config": "42ea",
	"./informatyka/games/page031_game11/gameData.config.js": "42ea",
	"./informatyka/games/page031_game11/img": "d732",
	"./informatyka/games/page031_game11/img/": "d732",
	"./informatyka/games/page031_game11/img/bcg.jpg": "10a8",
	"./informatyka/games/page031_game11/img/index": "d732",
	"./informatyka/games/page031_game11/img/index.js": "d732",
	"./informatyka/games/page034_game10/audio": "2867",
	"./informatyka/games/page034_game10/audio/": "2867",
	"./informatyka/games/page034_game10/audio/index": "2867",
	"./informatyka/games/page034_game10/audio/index.js": "2867",
	"./informatyka/games/page034_game10/audio/polecenie.mp3": "f0cd",
	"./informatyka/games/page034_game10/audio/z17s34-1.mp3": "75ef",
	"./informatyka/games/page034_game10/audio/z17s34-2.mp3": "ba13",
	"./informatyka/games/page034_game10/audio/z17s34-3.mp3": "9c46",
	"./informatyka/games/page034_game10/audio/z17s34-4.mp3": "91c2",
	"./informatyka/games/page034_game10/audio/z17s34-5.mp3": "11f2",
	"./informatyka/games/page034_game10/audio/z17s34-6.mp3": "a296",
	"./informatyka/games/page034_game10/audio/z17s34s1a.mp3": "3e37",
	"./informatyka/games/page034_game10/audio/z17s34s1b.mp3": "fa70",
	"./informatyka/games/page034_game10/config": "4d70",
	"./informatyka/games/page034_game10/config.js": "4d70",
	"./informatyka/games/page034_game10/gameData.config": "07c3",
	"./informatyka/games/page034_game10/gameData.config.js": "07c3",
	"./informatyka/games/page034_game10/img": "9da8",
	"./informatyka/games/page034_game10/img/": "9da8",
	"./informatyka/games/page034_game10/img/bcg.jpg": "7637",
	"./informatyka/games/page034_game10/img/index": "9da8",
	"./informatyka/games/page034_game10/img/index.js": "9da8",
	"./informatyka/games/page035_game10/audio": "7e51",
	"./informatyka/games/page035_game10/audio/": "7e51",
	"./informatyka/games/page035_game10/audio/index": "7e51",
	"./informatyka/games/page035_game10/audio/index.js": "7e51",
	"./informatyka/games/page035_game10/audio/polecenie.mp3": "7e92",
	"./informatyka/games/page035_game10/audio/z17s35-10.mp3": "567e",
	"./informatyka/games/page035_game10/audio/z17s35-11.mp3": "5ea4",
	"./informatyka/games/page035_game10/audio/z17s35-12.mp3": "d39c",
	"./informatyka/games/page035_game10/audio/z17s35-13.mp3": "b1ac",
	"./informatyka/games/page035_game10/audio/z17s35-7.mp3": "091c",
	"./informatyka/games/page035_game10/audio/z17s35-8.mp3": "5fa9",
	"./informatyka/games/page035_game10/audio/z17s35-9.mp3": "dc94",
	"./informatyka/games/page035_game10/config": "ab01",
	"./informatyka/games/page035_game10/config.js": "ab01",
	"./informatyka/games/page035_game10/gameData.config": "e3e5",
	"./informatyka/games/page035_game10/gameData.config.js": "e3e5",
	"./informatyka/games/page035_game10/img": "4432",
	"./informatyka/games/page035_game10/img/": "4432",
	"./informatyka/games/page035_game10/img/bcg.jpg": "ff89",
	"./informatyka/games/page035_game10/img/bcg2.jpg": "dfc6",
	"./informatyka/games/page035_game10/img/bcg3.jpg": "5d19",
	"./informatyka/games/page035_game10/img/index": "4432",
	"./informatyka/games/page035_game10/img/index.js": "4432",
	"./informatyka/games/page035_game11/audio": "84d7",
	"./informatyka/games/page035_game11/audio/": "84d7",
	"./informatyka/games/page035_game11/audio/index": "84d7",
	"./informatyka/games/page035_game11/audio/index.js": "84d7",
	"./informatyka/games/page035_game11/config": "a309",
	"./informatyka/games/page035_game11/config.js": "a309",
	"./informatyka/games/page035_game11/gameData.config": "3e4b",
	"./informatyka/games/page035_game11/gameData.config.js": "3e4b",
	"./informatyka/games/page035_game11/img": "00c6",
	"./informatyka/games/page035_game11/img/": "00c6",
	"./informatyka/games/page035_game11/img/index": "00c6",
	"./informatyka/games/page035_game11/img/index.js": "00c6",
	"./informatyka/games/page035_game12/audio": "dd85",
	"./informatyka/games/page035_game12/audio/": "dd85",
	"./informatyka/games/page035_game12/audio/index": "dd85",
	"./informatyka/games/page035_game12/audio/index.js": "dd85",
	"./informatyka/games/page035_game12/config": "188f",
	"./informatyka/games/page035_game12/config.js": "188f",
	"./informatyka/games/page035_game12/gameData.config": "6ba4",
	"./informatyka/games/page035_game12/gameData.config.js": "6ba4",
	"./informatyka/games/page035_game12/img": "7f0e",
	"./informatyka/games/page035_game12/img/": "7f0e",
	"./informatyka/games/page035_game12/img/index": "7f0e",
	"./informatyka/games/page035_game12/img/index.js": "7f0e",
	"./informatyka/games/page037_game10/audio": "0239",
	"./informatyka/games/page037_game10/audio/": "0239",
	"./informatyka/games/page037_game10/audio/index": "0239",
	"./informatyka/games/page037_game10/audio/index.js": "0239",
	"./informatyka/games/page037_game10/audio/polecenie.mp3": "c5b1",
	"./informatyka/games/page037_game10/audio/z18s37-1.mp3": "9aa2",
	"./informatyka/games/page037_game10/audio/z18s37-2.mp3": "8845",
	"./informatyka/games/page037_game10/config": "9543",
	"./informatyka/games/page037_game10/config.js": "9543",
	"./informatyka/games/page037_game10/gameData.config": "86c5",
	"./informatyka/games/page037_game10/gameData.config.js": "86c5",
	"./informatyka/games/page037_game10/img": "1968",
	"./informatyka/games/page037_game10/img/": "1968",
	"./informatyka/games/page037_game10/img/bcg.jpg": "3a42",
	"./informatyka/games/page037_game10/img/index": "1968",
	"./informatyka/games/page037_game10/img/index.js": "1968",
	"./informatyka/games/page037_game11/audio": "7797",
	"./informatyka/games/page037_game11/audio/": "7797",
	"./informatyka/games/page037_game11/audio/index": "7797",
	"./informatyka/games/page037_game11/audio/index.js": "7797",
	"./informatyka/games/page037_game11/audio/polecenie.mp3": "9902",
	"./informatyka/games/page037_game11/audio/z18s37-1.mp3": "0498",
	"./informatyka/games/page037_game11/audio/z18s37-2.mp3": "2c14",
	"./informatyka/games/page037_game11/audio/z18s37-3.mp3": "2960",
	"./informatyka/games/page037_game11/audio/z18s37-4.mp3": "0417",
	"./informatyka/games/page037_game11/config": "fd0a",
	"./informatyka/games/page037_game11/config.js": "fd0a",
	"./informatyka/games/page037_game11/gameData.config": "bf1f",
	"./informatyka/games/page037_game11/gameData.config.js": "bf1f",
	"./informatyka/games/page037_game11/img": "7478",
	"./informatyka/games/page037_game11/img/": "7478",
	"./informatyka/games/page037_game11/img/bcg.jpg": "efd1",
	"./informatyka/games/page037_game11/img/index": "7478",
	"./informatyka/games/page037_game11/img/index.js": "7478",
	"./informatyka/games/page037_game12/audio": "649b",
	"./informatyka/games/page037_game12/audio/": "649b",
	"./informatyka/games/page037_game12/audio/index": "649b",
	"./informatyka/games/page037_game12/audio/index.js": "649b",
	"./informatyka/games/page037_game12/audio/polecenie.mp3": "49821",
	"./informatyka/games/page037_game12/audio/z18s37-c1.mp3": "ed42",
	"./informatyka/games/page037_game12/audio/z18s37-c2.mp3": "2853",
	"./informatyka/games/page037_game12/audio/z18s37-c3.mp3": "037f",
	"./informatyka/games/page037_game12/audio/z18s37-c4.mp3": "4028",
	"./informatyka/games/page037_game12/config": "f7bb",
	"./informatyka/games/page037_game12/config.js": "f7bb",
	"./informatyka/games/page037_game12/gameData.config": "bf19",
	"./informatyka/games/page037_game12/gameData.config.js": "bf19",
	"./informatyka/games/page037_game12/img": "f236",
	"./informatyka/games/page037_game12/img/": "f236",
	"./informatyka/games/page037_game12/img/bcg.jpg": "7a79",
	"./informatyka/games/page037_game12/img/index": "f236",
	"./informatyka/games/page037_game12/img/index.js": "f236",
	"./informatyka/games/page039_game10/audio": "e298",
	"./informatyka/games/page039_game10/audio/": "e298",
	"./informatyka/games/page039_game10/audio/index": "e298",
	"./informatyka/games/page039_game10/audio/index.js": "e298",
	"./informatyka/games/page039_game10/audio/polecenie.mp3": "704c",
	"./informatyka/games/page039_game10/audio/z19s39-1.mp3": "0c7f",
	"./informatyka/games/page039_game10/audio/z19s39-2.mp3": "5482",
	"./informatyka/games/page039_game10/audio/z19s39-3.mp3": "2bc2",
	"./informatyka/games/page039_game10/audio/z19s39-4.mp3": "ce49",
	"./informatyka/games/page039_game10/audio/z19s39-5.mp3": "376f",
	"./informatyka/games/page039_game10/audio/z19s39-6.mp3": "723b",
	"./informatyka/games/page039_game10/audio/z19s39-7.mp3": "8f27",
	"./informatyka/games/page039_game10/config": "7e22",
	"./informatyka/games/page039_game10/config.js": "7e22",
	"./informatyka/games/page039_game10/gameData.config": "8697",
	"./informatyka/games/page039_game10/gameData.config.js": "8697",
	"./informatyka/games/page039_game10/img": "eba5",
	"./informatyka/games/page039_game10/img/": "eba5",
	"./informatyka/games/page039_game10/img/bcg.jpg": "8462",
	"./informatyka/games/page039_game10/img/bcg2.jpg": "f982",
	"./informatyka/games/page039_game10/img/index": "eba5",
	"./informatyka/games/page039_game10/img/index.js": "eba5",
	"./informatyka/games/page039_game11/audio": "cc74",
	"./informatyka/games/page039_game11/audio/": "cc74",
	"./informatyka/games/page039_game11/audio/index": "cc74",
	"./informatyka/games/page039_game11/audio/index.js": "cc74",
	"./informatyka/games/page039_game11/config": "bbcf",
	"./informatyka/games/page039_game11/config.js": "bbcf",
	"./informatyka/games/page039_game11/gameData.config": "c48c",
	"./informatyka/games/page039_game11/gameData.config.js": "c48c",
	"./informatyka/games/page039_game11/img": "5770",
	"./informatyka/games/page039_game11/img/": "5770",
	"./informatyka/games/page039_game11/img/index": "5770",
	"./informatyka/games/page039_game11/img/index.js": "5770",
	"./informatyka/games/page040_game10/audio": "624b",
	"./informatyka/games/page040_game10/audio/": "624b",
	"./informatyka/games/page040_game10/audio/index": "624b",
	"./informatyka/games/page040_game10/audio/index.js": "624b",
	"./informatyka/games/page040_game10/audio/polecenie.mp3": "6f7f",
	"./informatyka/games/page040_game10/audio/z20s40-1.mp3": "0191",
	"./informatyka/games/page040_game10/audio/z20s40-2.mp3": "f7bd",
	"./informatyka/games/page040_game10/config": "0388",
	"./informatyka/games/page040_game10/config.js": "0388",
	"./informatyka/games/page040_game10/gameData.config": "d95f",
	"./informatyka/games/page040_game10/gameData.config.js": "d95f",
	"./informatyka/games/page040_game10/img": "3049",
	"./informatyka/games/page040_game10/img/": "3049",
	"./informatyka/games/page040_game10/img/bcg.jpg": "1487",
	"./informatyka/games/page040_game10/img/index": "3049",
	"./informatyka/games/page040_game10/img/index.js": "3049",
	"./informatyka/games/page042_game10/audio": "febe",
	"./informatyka/games/page042_game10/audio/": "febe",
	"./informatyka/games/page042_game10/audio/index": "febe",
	"./informatyka/games/page042_game10/audio/index.js": "febe",
	"./informatyka/games/page042_game10/audio/polecenie.mp3": "f9f2",
	"./informatyka/games/page042_game10/audio/z21s42-1.mp3": "0d85",
	"./informatyka/games/page042_game10/audio/z21s42-2.mp3": "2336",
	"./informatyka/games/page042_game10/config": "9cc0",
	"./informatyka/games/page042_game10/config.js": "9cc0",
	"./informatyka/games/page042_game10/gameData.config": "e43a",
	"./informatyka/games/page042_game10/gameData.config.js": "e43a",
	"./informatyka/games/page042_game10/img": "4b0b",
	"./informatyka/games/page042_game10/img/": "4b0b",
	"./informatyka/games/page042_game10/img/bcg.jpg": "e127",
	"./informatyka/games/page042_game10/img/index": "4b0b",
	"./informatyka/games/page042_game10/img/index.js": "4b0b",
	"./informatyka/games/page043_game10/audio": "598c",
	"./informatyka/games/page043_game10/audio/": "598c",
	"./informatyka/games/page043_game10/audio/index": "598c",
	"./informatyka/games/page043_game10/audio/index.js": "598c",
	"./informatyka/games/page043_game10/audio/polecenie.mp3": "fedc",
	"./informatyka/games/page043_game10/audio/z21s43-1.mp3": "17f6",
	"./informatyka/games/page043_game10/audio/z21s43-2.mp3": "aeb2",
	"./informatyka/games/page043_game10/config": "7629",
	"./informatyka/games/page043_game10/config.js": "7629",
	"./informatyka/games/page043_game10/gameData.config": "8e1a",
	"./informatyka/games/page043_game10/gameData.config.js": "8e1a",
	"./informatyka/games/page043_game10/img": "67c5",
	"./informatyka/games/page043_game10/img/": "67c5",
	"./informatyka/games/page043_game10/img/bcg.jpg": "7bf1",
	"./informatyka/games/page043_game10/img/index": "67c5",
	"./informatyka/games/page043_game10/img/index.js": "67c5",
	"./informatyka/games/page045_game10/audio": "c42fc",
	"./informatyka/games/page045_game10/audio/": "c42fc",
	"./informatyka/games/page045_game10/audio/index": "c42fc",
	"./informatyka/games/page045_game10/audio/index.js": "c42fc",
	"./informatyka/games/page045_game10/audio/polecenie.mp3": "4b77",
	"./informatyka/games/page045_game10/audio/z22s45-1.mp3": "0ffb",
	"./informatyka/games/page045_game10/audio/z22s45-2.mp3": "53ce",
	"./informatyka/games/page045_game10/audio/z22s45-3.mp3": "c663",
	"./informatyka/games/page045_game10/audio/z22s45-4.mp3": "5c6e",
	"./informatyka/games/page045_game10/audio/z22s45-5.mp3": "4a7a",
	"./informatyka/games/page045_game10/config": "ebe3",
	"./informatyka/games/page045_game10/config.js": "ebe3",
	"./informatyka/games/page045_game10/gameData.config": "520e",
	"./informatyka/games/page045_game10/gameData.config.js": "520e",
	"./informatyka/games/page045_game10/img": "65b8",
	"./informatyka/games/page045_game10/img/": "65b8",
	"./informatyka/games/page045_game10/img/bcg.jpg": "e53a",
	"./informatyka/games/page045_game10/img/bcg2.jpg": "b3b9",
	"./informatyka/games/page045_game10/img/index": "65b8",
	"./informatyka/games/page045_game10/img/index.js": "65b8",
	"./informatyka/games/page045_game11/audio": "2417",
	"./informatyka/games/page045_game11/audio/": "2417",
	"./informatyka/games/page045_game11/audio/index": "2417",
	"./informatyka/games/page045_game11/audio/index.js": "2417",
	"./informatyka/games/page045_game11/config": "c42e",
	"./informatyka/games/page045_game11/config.js": "c42e",
	"./informatyka/games/page045_game11/gameData.config": "4c8a",
	"./informatyka/games/page045_game11/gameData.config.js": "4c8a",
	"./informatyka/games/page045_game11/img": "e657",
	"./informatyka/games/page045_game11/img/": "e657",
	"./informatyka/games/page045_game11/img/index": "e657",
	"./informatyka/games/page045_game11/img/index.js": "e657",
	"./informatyka/games/page050_game10/audio": "ffa0",
	"./informatyka/games/page050_game10/audio/": "ffa0",
	"./informatyka/games/page050_game10/audio/index": "ffa0",
	"./informatyka/games/page050_game10/audio/index.js": "ffa0",
	"./informatyka/games/page050_game10/audio/polecenie.mp3": "b54f",
	"./informatyka/games/page050_game10/audio/z25s50-1.mp3": "cb4c",
	"./informatyka/games/page050_game10/audio/z25s50-2.mp3": "1c9e",
	"./informatyka/games/page050_game10/config": "1466",
	"./informatyka/games/page050_game10/config.js": "1466",
	"./informatyka/games/page050_game10/gameData.config": "e745",
	"./informatyka/games/page050_game10/gameData.config.js": "e745",
	"./informatyka/games/page050_game10/img": "c931",
	"./informatyka/games/page050_game10/img/": "c931",
	"./informatyka/games/page050_game10/img/bcg.jpg": "8801",
	"./informatyka/games/page050_game10/img/index": "c931",
	"./informatyka/games/page050_game10/img/index.js": "c931",
	"./informatyka/games/page051_game10/audio": "9527",
	"./informatyka/games/page051_game10/audio/": "9527",
	"./informatyka/games/page051_game10/audio/index": "9527",
	"./informatyka/games/page051_game10/audio/index.js": "9527",
	"./informatyka/games/page051_game10/audio/polecenie.mp3": "b8c3",
	"./informatyka/games/page051_game10/audio/z25s51-1.mp3": "dca7",
	"./informatyka/games/page051_game10/audio/z25s51-10.mp3": "8101",
	"./informatyka/games/page051_game10/audio/z25s51-11.mp3": "016b",
	"./informatyka/games/page051_game10/audio/z25s51-2.mp3": "0b6e",
	"./informatyka/games/page051_game10/audio/z25s51-3.mp3": "fcac",
	"./informatyka/games/page051_game10/audio/z25s51-4.mp3": "62d0",
	"./informatyka/games/page051_game10/audio/z25s51-5.mp3": "ebea",
	"./informatyka/games/page051_game10/audio/z25s51-6.mp3": "45db",
	"./informatyka/games/page051_game10/audio/z25s51-7.mp3": "9da5",
	"./informatyka/games/page051_game10/audio/z25s51-8.mp3": "f57a",
	"./informatyka/games/page051_game10/audio/z25s51-9.mp3": "1f21",
	"./informatyka/games/page051_game10/config": "e51e",
	"./informatyka/games/page051_game10/config.js": "e51e",
	"./informatyka/games/page051_game10/gameData.config": "3e26",
	"./informatyka/games/page051_game10/gameData.config.js": "3e26",
	"./informatyka/games/page051_game10/img": "923b",
	"./informatyka/games/page051_game10/img/": "923b",
	"./informatyka/games/page051_game10/img/bcg.jpg": "1888",
	"./informatyka/games/page051_game10/img/bcg2.jpg": "161a",
	"./informatyka/games/page051_game10/img/bcg3.jpg": "77fb",
	"./informatyka/games/page051_game10/img/index": "923b",
	"./informatyka/games/page051_game10/img/index.js": "923b",
	"./informatyka/games/page051_game11/audio": "a456",
	"./informatyka/games/page051_game11/audio/": "a456",
	"./informatyka/games/page051_game11/audio/index": "a456",
	"./informatyka/games/page051_game11/audio/index.js": "a456",
	"./informatyka/games/page051_game11/config": "9026",
	"./informatyka/games/page051_game11/config.js": "9026",
	"./informatyka/games/page051_game11/gameData.config": "0463",
	"./informatyka/games/page051_game11/gameData.config.js": "0463",
	"./informatyka/games/page051_game11/img": "81af",
	"./informatyka/games/page051_game11/img/": "81af",
	"./informatyka/games/page051_game11/img/index": "81af",
	"./informatyka/games/page051_game11/img/index.js": "81af",
	"./informatyka/games/page051_game12/audio": "ff90",
	"./informatyka/games/page051_game12/audio/": "ff90",
	"./informatyka/games/page051_game12/audio/index": "ff90",
	"./informatyka/games/page051_game12/audio/index.js": "ff90",
	"./informatyka/games/page051_game12/config": "68d2",
	"./informatyka/games/page051_game12/config.js": "68d2",
	"./informatyka/games/page051_game12/gameData.config": "3d9b",
	"./informatyka/games/page051_game12/gameData.config.js": "3d9b",
	"./informatyka/games/page051_game12/img": "e129",
	"./informatyka/games/page051_game12/img/": "e129",
	"./informatyka/games/page051_game12/img/index": "e129",
	"./informatyka/games/page051_game12/img/index.js": "e129",
	"./informatyka/games/page997_game1/audio": "4197",
	"./informatyka/games/page997_game1/audio/": "4197",
	"./informatyka/games/page997_game1/audio/f.mp3": "5c18",
	"./informatyka/games/page997_game1/audio/index": "4197",
	"./informatyka/games/page997_game1/audio/index.js": "4197",
	"./informatyka/games/page997_game1/audio/t.mp3": "530e",
	"./informatyka/games/page997_game1/audio/z2c2brawo.mp3": "1928",
	"./informatyka/games/page997_game1/audio/z7c2.mp3": "5c69",
	"./informatyka/games/page997_game1/config": "225b",
	"./informatyka/games/page997_game1/config.js": "225b",
	"./informatyka/games/page997_game1/gameData.config": "98de",
	"./informatyka/games/page997_game1/gameData.config.js": "98de",
	"./informatyka/games/page997_game1/img": "fd29",
	"./informatyka/games/page997_game1/img/": "fd29",
	"./informatyka/games/page997_game1/img/00.png": "94f0",
	"./informatyka/games/page997_game1/img/01.png": "51a5",
	"./informatyka/games/page997_game1/img/02.png": "5886f",
	"./informatyka/games/page997_game1/img/03.png": "cc8fc",
	"./informatyka/games/page997_game1/img/1.png": "bee7",
	"./informatyka/games/page997_game1/img/2.png": "f3f6b",
	"./informatyka/games/page997_game1/img/3.png": "e744",
	"./informatyka/games/page997_game1/img/4.png": "7769",
	"./informatyka/games/page997_game1/img/5.png": "5ce3",
	"./informatyka/games/page997_game1/img/6.png": "08d1",
	"./informatyka/games/page997_game1/img/7.png": "530b",
	"./informatyka/games/page997_game1/img/8.png": "30d7",
	"./informatyka/games/page997_game1/img/9.png": "eee0",
	"./informatyka/games/page997_game1/img/bcg.png": "4352",
	"./informatyka/games/page997_game1/img/des.jpg": "e5c76",
	"./informatyka/games/page997_game1/img/des.png": "b32d",
	"./informatyka/games/page997_game1/img/find.png": "e523c",
	"./informatyka/games/page997_game1/img/index": "fd29",
	"./informatyka/games/page997_game1/img/index.js": "fd29",
	"./informatyka/games/page997_game2/audio": "bbf5",
	"./informatyka/games/page997_game2/audio/": "bbf5",
	"./informatyka/games/page997_game2/audio/f.mp3": "e5b8",
	"./informatyka/games/page997_game2/audio/index": "bbf5",
	"./informatyka/games/page997_game2/audio/index.js": "bbf5",
	"./informatyka/games/page997_game2/audio/t.mp3": "4cf2",
	"./informatyka/games/page997_game2/audio/z22c1-brawo.mp3": "f6ab",
	"./informatyka/games/page997_game2/audio/z22c1.mp3": "29f6",
	"./informatyka/games/page997_game2/config": "87f4",
	"./informatyka/games/page997_game2/config.js": "87f4",
	"./informatyka/games/page997_game2/gameData.config": "0eae",
	"./informatyka/games/page997_game2/gameData.config.js": "0eae",
	"./informatyka/games/page997_game2/img": "f961",
	"./informatyka/games/page997_game2/img/": "f961",
	"./informatyka/games/page997_game2/img/00.png": "5581",
	"./informatyka/games/page997_game2/img/01.png": "9785b",
	"./informatyka/games/page997_game2/img/02.png": "65f9",
	"./informatyka/games/page997_game2/img/03.png": "c3c9",
	"./informatyka/games/page997_game2/img/04.png": "2ebb",
	"./informatyka/games/page997_game2/img/05.png": "ae35",
	"./informatyka/games/page997_game2/img/06.png": "0b20",
	"./informatyka/games/page997_game2/img/07.png": "abfa",
	"./informatyka/games/page997_game2/img/08.png": "634e",
	"./informatyka/games/page997_game2/img/09.png": "654c",
	"./informatyka/games/page997_game2/img/10.png": "928e",
	"./informatyka/games/page997_game2/img/11.png": "9b44",
	"./informatyka/games/page997_game2/img/12.png": "22d2",
	"./informatyka/games/page997_game2/img/13.png": "ecd9",
	"./informatyka/games/page997_game2/img/14.png": "5fe0",
	"./informatyka/games/page997_game2/img/15.png": "40c6",
	"./informatyka/games/page997_game2/img/16.png": "f9ef",
	"./informatyka/games/page997_game2/img/17.png": "93eb",
	"./informatyka/games/page997_game2/img/18.png": "e92f",
	"./informatyka/games/page997_game2/img/19.png": "fcb49",
	"./informatyka/games/page997_game2/img/20.png": "c7f2",
	"./informatyka/games/page997_game2/img/21.png": "49b1",
	"./informatyka/games/page997_game2/img/22.png": "ba18",
	"./informatyka/games/page997_game2/img/23.png": "8377",
	"./informatyka/games/page997_game2/img/bcg.png": "53b6",
	"./informatyka/games/page997_game2/img/f.png": "5005",
	"./informatyka/games/page997_game2/img/index": "f961",
	"./informatyka/games/page997_game2/img/index.js": "f961",
	"./informatyka/games/page997_game2/img/t.png": "9d42",
	"./informatyka/images/page002/002_2.jpg": "07e2",
	"./informatyka/images/page003/002 1.jpg": "a11f",
	"./informatyka/images/page004/004_dron.jpg": "d2df",
	"./informatyka/images/page004/004_komp.jpg": "e309",
	"./informatyka/images/page004/004_laptop.jpg": "c510",
	"./informatyka/images/page004/004_smartw.jpg": "73dd",
	"./informatyka/images/page004/004_tablet.jpg": "b9eb",
	"./informatyka/images/page004/Crop_00444_strona_004.jpg": "a851",
	"./informatyka/images/page005/005 1.jpg": "555f",
	"./informatyka/images/page005/005 2.jpg": "5e6c",
	"./informatyka/images/page006/006 1.jpg": "fa44",
	"./informatyka/images/page006/006 2.jpg": "7e7c",
	"./informatyka/images/page006/006 3.jpg": "5b36",
	"./informatyka/images/page006/006 4.jpg": "d0ca",
	"./informatyka/images/page006/006 5.jpg": "6fdd",
	"./informatyka/images/page006/006 6.jpg": "0010",
	"./informatyka/images/page006/006 7.jpg": "f749",
	"./informatyka/images/page007/007 1.jpg": "c127",
	"./informatyka/images/page007/007_2_punkt.jpg": "1a0e",
	"./informatyka/images/page007/007_3_punkt.jpg": "0441",
	"./informatyka/images/page007/007_5_razem.jpg": "2185",
	"./informatyka/images/page008/008.jpg": "7c6c",
	"./informatyka/images/page009/009 1.jpg": "dd22",
	"./informatyka/images/page009/009 2.jpg": "4e4e",
	"./informatyka/images/page009/009 3.jpg": "7512",
	"./informatyka/images/page010/010.jpg": "f17d",
	"./informatyka/images/page011/011 1.jpg": "ee15",
	"./informatyka/images/page011/011 2.jpg": "839e",
	"./informatyka/images/page012/012.jpg": "350b",
	"./informatyka/images/page013/013 1.jpg": "9c73",
	"./informatyka/images/page013/013 2.jpg": "88ae",
	"./informatyka/images/page014/014.jpg": "104c",
	"./informatyka/images/page015/015 1.jpg": "116a",
	"./informatyka/images/page015/015 2.jpg": "e3ee",
	"./informatyka/images/page016/016 1.jpg": "d04a",
	"./informatyka/images/page016/016 2.jpg": "c79f",
	"./informatyka/images/page016/017 1.jpg": "eee4",
	"./informatyka/images/page017/017 1.jpg": "27c0",
	"./informatyka/images/page017/017 2.jpg": "1ef2",
	"./informatyka/images/page017/017 3.jpg": "39ee",
	"./informatyka/images/page017/017 4.jpg": "5673",
	"./informatyka/images/page018/018.jpg": "12a9",
	"./informatyka/images/page019/019 1.jpg": "9e6e",
	"./informatyka/images/page019/019 2.jpg": "cc63",
	"./informatyka/images/page019/019 3.jpg": "44a9",
	"./informatyka/images/page020/020 11.jpg": "ff2e",
	"./informatyka/images/page020/020 3.jpg": "4aa7",
	"./informatyka/images/page020/020 4.jpg": "51fd",
	"./informatyka/images/page021/021 1.jpg": "3210",
	"./informatyka/images/page021/021 2.jpg": "e814",
	"./informatyka/images/page022/022.jpg": "e92c",
	"./informatyka/images/page023/023 1.jpg": "e09b",
	"./informatyka/images/page023/023 2.jpg": "a585",
	"./informatyka/images/page023/023 3.jpg": "4710",
	"./informatyka/images/page023/023 4.jpg": "67b3",
	"./informatyka/images/page023/023 5.jpg": "119e",
	"./informatyka/images/page024/024 1.jpg": "0920",
	"./informatyka/images/page024/024 2.jpg": "b7ca",
	"./informatyka/images/page025/025 1.jpg": "1ea9",
	"./informatyka/images/page025/025 2.jpg": "ce32",
	"./informatyka/images/page026/026 1.jpg": "aac5",
	"./informatyka/images/page026/026 2.jpg": "263e",
	"./informatyka/images/page027/027 1.jpg": "3b76",
	"./informatyka/images/page027/027 2.jpg": "9c93",
	"./informatyka/images/page027/027 3.jpg": "6103",
	"./informatyka/images/page028/028 1.jpg": "f186",
	"./informatyka/images/page028/028 2.jpg": "5b9d",
	"./informatyka/images/page028/028 3.jpg": "60ab",
	"./informatyka/images/page028/028 4.jpg": "5e71",
	"./informatyka/images/page028/028 5.jpg": "a21d",
	"./informatyka/images/page029/029 1.jpg": "0c5d",
	"./informatyka/images/page029/029 2.jpg": "a2a1",
	"./informatyka/images/page030/030 1.jpg": "4b1a",
	"./informatyka/images/page030/030 2.jpg": "8e2e",
	"./informatyka/images/page030/030 3.jpg": "398f",
	"./informatyka/images/page031/031 1.jpg": "d418",
	"./informatyka/images/page031/031 2.jpg": "3834",
	"./informatyka/images/page032/032 5.jpg": "9056",
	"./informatyka/images/page032/032 6.jpg": "9d8f",
	"./informatyka/images/page032/032 7.jpg": "2797",
	"./informatyka/images/page032/033 1.jpg": "f10a",
	"./informatyka/images/page032/033 2.jpg": "713e",
	"./informatyka/images/page033/032 11.jpg": "75c1",
	"./informatyka/images/page033/032 31.jpg": "69e7",
	"./informatyka/images/page033/032 41.jpg": "bcb35",
	"./informatyka/images/page033/033 4.jpg": "b30a",
	"./informatyka/images/page033/033 5.jpg": "700de",
	"./informatyka/images/page033/033 6.jpg": "6517",
	"./informatyka/images/page034/034 1.jpg": "0b00",
	"./informatyka/images/page034/034 4.jpg": "f2d2",
	"./informatyka/images/page034/034 5.jpg": "a69b",
	"./informatyka/images/page034/034.jpg": "106f",
	"./informatyka/images/page035/035 1.jpg": "e81f",
	"./informatyka/images/page035/035 2.jpg": "0495",
	"./informatyka/images/page035/035 3.jpg": "266d",
	"./informatyka/images/page036/036 1.jpg": "d58c",
	"./informatyka/images/page036/036 2.jpg": "6e8f",
	"./informatyka/images/page036/036 3.jpg": "6be4",
	"./informatyka/images/page036/036 4.jpg": "d3af",
	"./informatyka/images/page036/036 5.jpg": "b650",
	"./informatyka/images/page036/036 6.jpg": "51e1",
	"./informatyka/images/page037/037 1.jpg": "0268",
	"./informatyka/images/page037/037 2.jpg": "3f2d",
	"./informatyka/images/page037/037 3.jpg": "132c",
	"./informatyka/images/page038/038 1.jpg": "c12e",
	"./informatyka/images/page038/038 2.jpg": "7356",
	"./informatyka/images/page039/039 1.jpg": "0217",
	"./informatyka/images/page039/039 2.jpg": "fb4a",
	"./informatyka/images/page040/040 1.jpg": "a50d",
	"./informatyka/images/page040/040 2.jpg": "3a7c",
	"./informatyka/images/page041/041 1.jpg": "29c24",
	"./informatyka/images/page041/041 2.jpg": "f4ba",
	"./informatyka/images/page041/041 3.jpg": "129d",
	"./informatyka/images/page042/042 1.jpg": "a28c",
	"./informatyka/images/page042/042 2.jpg": "cbe4",
	"./informatyka/images/page043/043 1.jpg": "95f1",
	"./informatyka/images/page043/043 2.jpg": "5a8d",
	"./informatyka/images/page043/043 3.jpg": "2b62",
	"./informatyka/images/page043/043 4.jpg": "79ed",
	"./informatyka/images/page043/043 5.jpg": "61e0",
	"./informatyka/images/page043/043 6.jpg": "bbc8",
	"./informatyka/images/page044/044 1.jpg": "d6c2",
	"./informatyka/images/page044/044 2.jpg": "0f1f",
	"./informatyka/images/page044/044 3.jpg": "b901",
	"./informatyka/images/page044/044 4.jpg": "a6ed",
	"./informatyka/images/page044/044 5.jpg": "b678",
	"./informatyka/images/page044/044 6.jpg": "1b7a",
	"./informatyka/images/page045/045 1.jpg": "4bc1",
	"./informatyka/images/page045/045 2.jpg": "72d4",
	"./informatyka/images/page046/046 1.jpg": "ea39",
	"./informatyka/images/page046/046 2.jpg": "e17d",
	"./informatyka/images/page046/046 3.jpg": "9df2",
	"./informatyka/images/page046/046 4.jpg": "bd1d",
	"./informatyka/images/page046/046 5.jpg": "d201",
	"./informatyka/images/page047/047 1.jpg": "c840",
	"./informatyka/images/page047/047 2.jpg": "bd98",
	"./informatyka/images/page048/048 1.jpg": "2fd4",
	"./informatyka/images/page048/048 2.jpg": "0b64",
	"./informatyka/images/page049/049 1.jpg": "faf4",
	"./informatyka/images/page049/049 2.jpg": "376e",
	"./informatyka/images/page049/049 3.jpg": "61c7",
	"./informatyka/images/page050/050 1.jpg": "2ee80",
	"./informatyka/images/page050/050 2.jpg": "c12c",
	"./informatyka/images/page050/050_0.jpg": "c842",
	"./informatyka/images/page051/051 1.jpg": "ae55",
	"./informatyka/images/page051/051 2.jpg": "f509",
	"./informatyka/images/page051/051 3.jpg": "2199",
	"./informatyka/images/page051/051 4.jpg": "90c7",
	"./informatyka/images/page052/052 1.jpg": "8edb",
	"./informatyka/images/page052/052 2.jpg": "b996",
	"./informatyka/images/page052/052 3.jpg": "89c1",
	"./informatyka/images/page053/053 1.jpg": "9201",
	"./informatyka/images/page053/053 2.jpg": "16f6",
	"./informatyka/images/page053/053 3.jpg": "c407",
	"./informatyka/images/page053/053 4.jpg": "1a46",
	"./informatyka/images/page054/054.jpg": "8c39",
	"./informatyka/presentation": "63e5",
	"./informatyka/presentation/": "63e5",
	"./informatyka/presentation/index": "63e5",
	"./informatyka/presentation/index.js": "63e5",
	"./informatyka/scratchPad/page001_game0/config": "e248",
	"./informatyka/scratchPad/page001_game0/config.js": "e248",
	"./informatyka/scratchPad/page001_game1/config": "d406",
	"./informatyka/scratchPad/page001_game1/config.js": "d406",
	"./informatyka/scratchPad/page002_game0/config": "042d",
	"./informatyka/scratchPad/page002_game0/config.js": "042d",
	"./informatyka/scratchPad/page002_game1/config": "3ce6",
	"./informatyka/scratchPad/page002_game1/config.js": "3ce6",
	"./informatyka/scratchPad/page002_game2/config": "875e",
	"./informatyka/scratchPad/page002_game2/config.js": "875e",
	"./informatyka/scratchPad/page003_game0/config": "07ab",
	"./informatyka/scratchPad/page003_game0/config.js": "07ab",
	"./informatyka/scratchPad/page003_game1/config": "da6b",
	"./informatyka/scratchPad/page003_game1/config.js": "da6b",
	"./informatyka/scratchPad/page003_game2/config": "1f50",
	"./informatyka/scratchPad/page003_game2/config.js": "1f50",
	"./informatyka/scratchPad/page006_game0/config": "f5b2",
	"./informatyka/scratchPad/page006_game0/config.js": "f5b2",
	"./informatyka/scratchPad/page007_game0/config": "6c67",
	"./informatyka/scratchPad/page007_game0/config.js": "6c67",
	"./informatyka/scratchPad/page007_game1/config": "dcb2",
	"./informatyka/scratchPad/page007_game1/config.js": "dcb2",
	"./informatyka/scratchPad/page008_game0/config": "fc18",
	"./informatyka/scratchPad/page008_game0/config.js": "fc18",
	"./informatyka/scratchPad/page008_game1/config": "1773",
	"./informatyka/scratchPad/page008_game1/config.js": "1773",
	"./informatyka/scratchPad/page009_game0/config": "e0d2",
	"./informatyka/scratchPad/page009_game0/config.js": "e0d2",
	"./informatyka/scratchPad/page009_game1/config": "c308",
	"./informatyka/scratchPad/page009_game1/config.js": "c308"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d8a4";